import { useCallback, useEffect, useState, useRef, forwardRef, useImperativeHandle } from 'react'
import { useDispatch, useStore } from 'react-redux'
import { updateSupplierCardInfo, addCardAcceptanceEmails, removeCardAcceptanceEmails, uploadCardAuthorizationFormFile, addSupplierHistory } from '../../../../redux/actions/vendor'
import LoaderComponent from '../../../CommonComponents/LoaderComponent'
import CheckboxComponent from '../../../CommonComponents/CheckboxComponent'
import { Icon, Radio, RadioGroup, Toggle } from 'rsuite';
import DragDropFileUpload from '../../../CommonComponents/DragDropFileUpload'
import { BsCheckSquare, BsXSquare } from 'react-icons/bs'
import { AiOutlinePlusCircle } from 'react-icons/ai'

import VisaImg from '../../../../assets/svg/accept-visa-image.svg'
import MasterCardImg from '../../../../assets/svg/accept-mastercard-image.svg'
import AmexImg from '../../../../assets/svg/accept-amex-image.svg'
import { toast } from '../../../CommonComponents/ToastComponent/toast'
import { generateCardAcceptanceChangeLog, findDuplicateEmails, checkIsPhoneNumberValid, checkIsEmailValid, isDiffTwoObj, checkAmexCardConditonsAdded, checkVisaCardConditonsAdded, checkMasterCardConditonsAdded, onSupplierCardAccUpdate } from '../../../../services/helper'
import ThreeStateToggleButton from '../../../CommonComponents/ThreeStateToggleButton'
import { Loader } from 'rsuite';
import 'react-phone-input-2/lib/style.css'
import AdvanceAcceptanceDetailsModal from '../../modals/advance-acceptance-details-modal'
import Select from 'react-select';
import ToggleButton from '../../../CommonComponents/ToggleButton'
import { checkCardsFeeIdentical } from '../../../../services/checkCardFeeIdentical'
import { MdOutlineChangeCircle } from 'react-icons/md'
import ContactView from '../../../ContactsComponent/contactView'
import { getExistingContacts } from '../../../../redux/actions/contact'
import AllContacts from '../../../ContactsComponent/allContacts'

const SupplyCardAcceptance = forwardRef(({ cardColumns, masterSupplierId, onUpdateCompletenessScore = () => { }, onInfoChange, onCreateContact, onGetAllContactsData }, ref) => {

  const store = useStore().getState();
  const dispatch = useDispatch()
  const cardInfoSaveRef = useRef(null)

  const {
    vendor: {
      masterSupplierDetails,
      isLoadingMasterDetail,
    },
    domain: {
      currentDomain,
    }
  } = store

  const defaultCardFeeInfo = {
    showHideFee: {
      showAmexMinFee: false,
      showAmexMaxFee: false,
      showAmexIncrementalFee: false,
      showVisaMinFee: false,
      showVisaMaxFee: false,
      showVisaIncrementalFee: false,
      showMasterMinFee: false,
      showMasterMaxFee: false,
      showMasterIncrementalFee: false
    },
    feeValues: {
      amexProcessingFeeType: '$',
      amexProcessingFeeValue: '',
      amexMinFeeType: '$',
      amexMinFeeValue: '',
      amexMaxFeeType: '$',
      amexMaxFeeValue: '',
      amexIncrementalFeeType: '$',
      amexIncrementalFeeValue: '',
      amexIncrementalPayment: '',
      visaProcessingFeeType: '$',
      visaProcessingFeeValue: '',
      visaMinFeeType: '$',
      visaMinFeeValue: '',
      visaMaxFeeType: '$',
      visaMaxFeeValue: '',
      visaIncrementalFeeType: '$',
      visaIncrementalFeeValue: '',
      visaIncrementalPayment: '',
      masterProcessingFeeType: '$',
      masterProcessingFeeValue: '',
      masterMinFeeType: '$',
      masterMinFeeValue: '',
      masterMaxFeeType: '$',
      masterMaxFeeValue: '',
      masterIncrementalFeeType: '$',
      masterIncrementalFeeValue: '',
      masterIncrementalPayment: '',
    }
  }

  const paymentTermsOptions = [...Array(91)].map((_, i) => i);
  const product_specific_options = ['Parts and services', 'Taxes', 'Utilities', 'Subscriptions', 'Donations', 'Advertising', 'Insurance Premiums'];
  const remit_requirements_options = ['Invoice number', 'Account number', 'Credentials', 'Full card Number', 'Card last four digit', 'Full address'];
  const multiSelectColumns = ['productSpecificOptions', 'emailRemitRequirements', 'phoneRemitRequirements', 'faxRemitRequirements', 'onlineRemitRequirements', 'posRemitRequirements']

  const [showAmex, setShowAmex] = useState(false)
  const [showVisa, setShowVisa] = useState(false)
  const [showMaster, setShowMaster] = useState(false)
  const [cardAuthorizationFormFile, setCardAuthorizationFormFile] = useState(null)
  const [receivePaymentInfo, setReceivePaymentInfo] = useState({})
  const [isPhoneValid, setIsPhoneValid] = useState('')
  const [isFaxValid, setIsFaxValid] = useState(true)
  const [showCardPaymentTerms, setShowCardPaymentTerms] = useState(false)
  const [showCardDiscount, setShowCardDiscount] = useState(false)
  const [suppliercardInfo, setSuppliercardInfo] = useState({})
  const [tokenConfigurationValue, setTokenConfigurationValue] = useState('single-use-max-amount')
  const [cardDiscountValue, setCardDiscountValue] = useState('')
  const [suppliercardEmailsInfo, setSuppliercardEmailsInfo] = useState({})
  const [paymentTermValue, setpaymentTermValue] = useState('Upon Receipt')
  const [cardDiscountType, setCardDiscountType] = useState({
    label: '',
    value: ''
  })
  const [emailValues, setEmailValues] = useState([]);
  const [emailOldValues, setEmailOldValues] = useState([]);
  const [addEmailValues, setAddEmailValues] = useState({});
  const [removeEmailValues, setRemoveEmailValues] = useState({});
  const [isPortalUrlValid, setIsPortalUrlValid] = useState(true)
  const [isThirdPartyPortalUrlValid, setIsThirdPartyPortalUrlValid] = useState(true)
  const [supplierOldCardInfo, setSupplierOldCardInfo] = useState({})
  const [cardEmailType, setCardEmailType] = useState('')
  const [isValidatingPhone, setIsValidatingPhone] = useState(false)
  const [countryCode, setCountryCode] = useState('')
  const [isEmailValid, setIsEmailValid] = useState('')
  const [isEmailRisky, setIsEmailRisky] = useState('')
  const [isValidatingEmail, setIsValidatingEmail] = useState(false)
  const [showAdvanceAccDetailsModal, setShowAdvanceAccDetailsModal] = useState(false)
  const [deliveryMethodValues, setDeliveryMethodValues] = useState({
    email: false,
    phone: false,
    fax: false,
    online: false,
    pos: false,
  })
  const [deliveryMethodFeeValues, setDeliveryMethodFeeValues] = useState({})
  const [cardFeeInfo, setCardFeeInfo] = useState(defaultCardFeeInfo)
  const [showAcceptancePerCard, setShowAcceptancePerCard] = useState(false)
  const [accPerCardText, setAccPerCardText] = useState('Acceptance Per Card');
  const [genericFeeValues, setGenericFeeValues] = useState({
    showMinFee: false,
    showMaxFee: false,
    showIncrementalFee: false,
    showCreditCards: null,
    processingFeeType: '$',
    processingFeeValue: '',
    processingSecondFeeType: '$',
    processingSecondFeeValue: '',
    minFeeType: '$',
    minFeeValue: '',
    maxFeeType: '$',
    maxFeeValue: '',
    incrementalFeeType: '$',
    incrementalFeeValue: '',
    minPayment: '',
    maxPayment: '',
    incrementalPayment: '',
    showVariableFee: null,
    showCardConditions: null
  })

  const isEmailSelected = suppliercardInfo?.isAcceptCardPaymentByEmail ? 1 : 0
  const isPhoneSelected = suppliercardInfo?.isAcceptCardPaymentByPhone ? 1 : 0
  const isFaxSelected = suppliercardInfo?.isAcceptCardPaymentByFax ? 1 : 0
  const isOnlineSelected = suppliercardInfo?.isAcceptCardPaymentByOnlinePortal ? 1 : 0
  const isPosSelected = suppliercardInfo?.isAcceptPointOfSalePortal ? 1 : 0

  const totalDeliveryMethods = isEmailSelected + isPhoneSelected + isFaxSelected + isOnlineSelected + isPosSelected

  const deliveryMethodTabs = [
    suppliercardInfo?.isAcceptCardPaymentByEmail && ({
      label: 'Email',
      value: 'email'
    }),
    suppliercardInfo?.isAcceptCardPaymentByPhone && ({
      label: 'Phone',
      value: 'phone'
    }),
    suppliercardInfo?.isAcceptCardPaymentByFax && ({
      label: 'Fax',
      value: 'fax'
    }),
    suppliercardInfo?.isAcceptCardPaymentByOnlinePortal && ({
      label: 'Online',
      value: 'online'
    }),
    suppliercardInfo?.isAcceptPointOfSalePortal && ({
      label: 'Point of sale',
      value: 'pos'
    }),
  ]

  useImperativeHandle(ref, () => ({
    onCreateContactForEmailPhone,
    handleSave
  }))

  const [showAmexMinFee, setShowAmexMinFee] = useState(false)
  const [showAmexMaxFee, setShowAmexMaxFee] = useState(false)
  const [showAmexIncrementalFee, setShowAmexIncrementalFee] = useState(false)
  const [showVisaMinFee, setShowVisaMinFee] = useState(false)
  const [showVisaMaxFee, setShowVisaMaxFee] = useState(false)
  const [showVisaIncrementalFee, setShowVisaIncrementalFee] = useState(false)
  const [showMasterMinFee, setShowMasterMinFee] = useState(false)
  const [showMasterMaxFee, setShowMasterMaxFee] = useState(false)
  const [showMasterIncrementalFee, setShowMasterIncrementalFee] = useState(false)
  const [showAnotherProcessingFee, setShowAnotherProcessingFee] = useState(false)
  const [showAmexAnotherProcessingFee, setShowAmexAnotherProcessingFee] = useState(false)
  const [showVisaAnotherProcessingFee, setShowVisaAnotherProcessingFee] = useState(false)
  const [showMasterAnotherProcessingFee, setShowMasterAnotherProcessingFee] = useState(false)
  const [isIVRPhoneValid, setIsIVRPhoneValid] = useState('')
  const [isValidatingIVRPhone, setIsValidatingIVRPhone] = useState(false)
  const [ivrCountryCode, setIVRCountryCode] = useState('')
  const [showAllContacts, setShowAllContacts] = useState({
    email: false,
    phone: false,
    ivrPhone: false
  })
  const [existedContacts, setExistedContacts] = useState([])
  const [allContacts, setAllContacts] = useState([])
  const [isLoadingExistingContacts, setIsLoadingExistingContacts] = useState(false)
  const [currentContact, setCurrentContact] = useState({})
  const [isLoading, setIsLoading] = useState(false)
  const [enableAdvanceAcceptance, setIsEnableAdvanceAcceptance] = useState(false)
  const [disableAdvanceAcceptance, setIsDisableAdvanceAcceptance] = useState(false)

  const setInitialCardInfo = useCallback(async (columns, supplierDetails) => {
    let showAcceptancePerCard = supplierDetails?.cardInfo?.isAcceptAcceptancePerCard === null ? !checkCardsFeeIdentical(supplierDetails?.cardInfo) : supplierDetails?.cardInfo?.isAcceptAcceptancePerCard
    setShowAmex(supplierDetails?.cardInfo?.isAcceptAmericanExpress === null ? null : supplierDetails?.cardInfo?.isAcceptAmericanExpress)
    setShowMaster(supplierDetails?.cardInfo?.isAcceptMasterCard === null ? null : supplierDetails?.cardInfo?.isAcceptMasterCard)
    setShowVisa(supplierDetails?.cardInfo?.isAcceptVisa === null ? null : supplierDetails?.cardInfo?.isAcceptVisa)
    setShowCardPaymentTerms(supplierDetails?.cardInfo?.isAcceptCardPaymentTerms === null ? null : supplierDetails?.cardInfo?.isAcceptCardPaymentTerms)
    setShowCardDiscount(supplierDetails?.cardInfo?.isAcceptCardDiscount === null ? null : supplierDetails?.cardInfo?.isAcceptCardDiscount)
    setTokenConfigurationValue(supplierDetails?.cardInfo?.tokenType || 'single-use-max-amount')
    setpaymentTermValue(supplierDetails?.cardInfo?.cardPaymentTermsvalue || 'Upon Receipt')
    setCardDiscountType({
      label: !supplierDetails?.cardInfo?.cardDiscountType ? '%' : supplierDetails?.cardInfo?.cardDiscountType === 'Percentage' ? '%' : '$',
      value: supplierDetails?.cardInfo?.cardDiscountType || 'Percentage',
    })

    setShowAmexMinFee(supplierDetails?.cardInfo?.amexMinPaymentFeeValue ? true : false)
    setShowAmexMaxFee(supplierDetails?.cardInfo?.amexMaxPaymentFeeValue ? true : false)
    setShowAmexIncrementalFee((supplierDetails?.cardInfo?.amexIncrementalFeeValue || supplierDetails?.cardInfo?.amexIncrementalPaymentAmount) ? true : false)
    setShowVisaMinFee(supplierDetails?.cardInfo?.visaMinPaymentFeeValue ? true : false)
    setShowVisaMaxFee(supplierDetails?.cardInfo?.visaMaxPaymentFeeValue ? true : false)
    setShowVisaIncrementalFee((supplierDetails?.cardInfo?.visaIncrementalFeeValue || supplierDetails?.cardInfo?.visaIncrementalPaymentAmount) ? true : false)
    setShowMasterMinFee(supplierDetails?.cardInfo?.mastercardMinPaymentFeeValue ? true : false)
    setShowMasterMaxFee(supplierDetails?.cardInfo?.mastercardMaxPaymentFeeValue ? true : false)
    setShowMasterIncrementalFee((supplierDetails?.cardInfo?.mastercardIncrementalFeeValue || supplierDetails?.cardInfo?.mastercardIncrementalPaymentAmount) ? true : false)
    setShowAcceptancePerCard(showAcceptancePerCard)
    setShowAmexAnotherProcessingFee(supplierDetails?.cardInfo?.amexSecondProcessingFeeValue ? true : false)
    setShowVisaAnotherProcessingFee(supplierDetails?.cardInfo?.visaSecondProcessingFeeValue ? true : false)
    setShowMasterAnotherProcessingFee(supplierDetails?.cardInfo?.mastercardSecondProcessingFeeValue ? true : false)
    setShowAnotherProcessingFee(showAcceptancePerCard ? false : supplierDetails?.cardInfo?.amexSecondProcessingFeeValue ? true : false)
    setGenericFeeValues({
      ...genericFeeValues,
      'showCreditCards': (supplierDetails?.cardInfo?.isAcceptAmericanExpress === null && supplierDetails?.cardInfo?.isAcceptMasterCard === null && supplierDetails?.cardInfo?.isAcceptVisa === null) ? null : (supplierDetails?.cardInfo?.isAcceptAmericanExpress && supplierDetails?.cardInfo?.isAcceptMasterCard && supplierDetails?.cardInfo?.isAcceptVisa) ? true : false,
      'processingFeeType': showAcceptancePerCard ? '$' : supplierDetails?.cardInfo?.amexProcessingFeeType || '$',
      'processingFeeValue': showAcceptancePerCard ? '' : supplierDetails?.cardInfo?.amexProcessingFeeValue,
      'processingSecondFeeType': showAcceptancePerCard ? '$' : supplierDetails?.cardInfo?.amexSecondProcessingFeeType || '$',
      'processingSecondFeeValue': showAcceptancePerCard ? '' : supplierDetails?.cardInfo?.amexSecondProcessingFeeValue,
      'minFeeType': showAcceptancePerCard ? '$' : supplierDetails?.cardInfo?.amexMinPaymentFeeType || '$',
      'minFeeValue': showAcceptancePerCard ? '' : supplierDetails?.cardInfo?.amexMinPaymentFeeValue,
      'maxFeeType': showAcceptancePerCard ? '$' : supplierDetails?.cardInfo?.amexMaxPaymentFeeType || '$',
      'maxFeeValue': showAcceptancePerCard ? '' : supplierDetails?.cardInfo?.amexMaxPaymentFeeValue,
      'incrementalFeeType': showAcceptancePerCard ? '$' : supplierDetails?.cardInfo?.amexIncrementalFeeType || '$',
      'incrementalFeeValue': showAcceptancePerCard ? '' : supplierDetails?.cardInfo?.amexIncrementalFeeValue,
      'minPayment': showAcceptancePerCard ? '' : supplierDetails?.cardInfo?.americanExpressMinPaymnet,
      'maxPayment': showAcceptancePerCard ? '' : supplierDetails?.cardInfo?.americanExpressMaxPayment,
      'incrementalPayment': showAcceptancePerCard ? '' : supplierDetails?.cardInfo?.amexIncrementalPaymentAmount,
      'showMinFee': showAcceptancePerCard ? false : supplierDetails?.cardInfo?.amexMinPaymentFeeValue ? true : false,
      'showMaxFee': showAcceptancePerCard ? false : supplierDetails?.cardInfo?.amexMaxPaymentFeeValue ? true : false,
      'showIncrementalFee': showAcceptancePerCard ? false : supplierDetails?.cardInfo?.amexIncrementalFeeValue ? true : false,
      'showVariableFee': (supplierDetails?.cardInfo?.isAcceptAmexVariableFee === null && supplierDetails?.cardInfo?.isAcceptVisaVariableFee === null && supplierDetails?.cardInfo?.isAcceptMasterCardVariableFee === null) ? null : (supplierDetails?.cardInfo?.isAcceptAmexVariableFee && supplierDetails?.cardInfo?.isAcceptVisaVariableFee && supplierDetails?.cardInfo?.isAcceptMasterCardVariableFee) ? true : false,
      'showCardConditions': (supplierDetails?.cardInfo?.isAcceptAmexCardConditions === null && supplierDetails?.cardInfo?.isAcceptVisaCardConditions === null && supplierDetails?.cardInfo?.isAcceptMastercardCardConditions === null) ? null : (supplierDetails?.cardInfo?.isAcceptAmexCardConditions && supplierDetails?.cardInfo?.isAcceptVisaCardConditions && supplierDetails?.cardInfo?.isAcceptMastercardCardConditions) ? true : false
    })

    showAcceptancePerCard ? setAccPerCardText('Generic Fee Structure') : setAccPerCardText('Acceptance Per Card')

    var feeInfo = {}
    supplierDetails?.cardFeeInfo?.map((feeData) => {
      feeInfo = {
        ...feeInfo,
        [feeData?.deliveryMethod]: feeData
      }
    })
    setDeliveryMethodFeeValues(feeInfo)

    const tmpCardInfo = {}
    const usArray = ['united states', 'usa', 'us']

    columns.forEach(column => {
      if (column.datatype === 'currency') {
        tmpCardInfo[column.name] = supplierDetails?.cardInfo?.[column.name]?.match(/^(\d+)((\,)(\d+))*((\,))*(\.\d{0,2})?$/gi) ? supplierDetails?.cardInfo?.[column.name].match(/^(\d+)((\,)(\d+))*((\,))*(\.\d{0,2})?$/gi)[0] : ''
      } else if (column.datatype === 'percent') {
        tmpCardInfo[column.name] = supplierDetails?.cardInfo?.[column.name]?.match(/^\d{0,2}(\.\d{0,2})?/gi) ? supplierDetails?.cardInfo?.[column.name].match(/^\d{0,2}(\.\d{0,2})?/gi)[0] : ''
      } else if (column.datatype === 'integer') {
        if (column.name === 'cardPaymentByPhoneValue' || column.name === 'cardPaymentIVRPhone') {
          const tmpValue = supplierDetails?.cardInfo[column.name] || ''
          const phone = tmpValue && !/^(\d{1,}|[(]?[0-9]+[)])?([-]?[\s]?[0-9]){10}$/i.test(tmpValue) && /^\d+$/.test(tmpValue) ? supplierDetails?.contacts?.find(data => data?.id === parseInt(tmpValue))?.phone : tmpValue || ''
          if (phone && (!/^(\d{1,}|[(]?[0-9]+[)])?([-]?[\s]?[0-9]){10}$/i.test(phone) || phone?.length <= 3)) {
            tmpCardInfo[column.name] = '';
          } else {
            tmpCardInfo[column.name] = !phone ? '' : supplierDetails?.baseInfo?.['country'] && usArray.includes(supplierDetails?.baseInfo?.['country'].toLowerCase()) && phone.startsWith('1') ? phone : ((supplierDetails?.baseInfo?.['country'] && !usArray.includes(supplierDetails?.baseInfo?.['country'].toLowerCase()))) ? phone : phone.startsWith('1') ? phone : '1 ' + phone
          }
          if (column.name === 'cardPaymentByPhoneValue') {
            tmpCardInfo.phoneContactId = tmpValue ? supplierDetails?.contacts?.find(data => data?.id === parseInt(tmpValue))?.id : null
          } else {
            tmpCardInfo.ivrPhoneContactId = tmpValue ? supplierDetails?.contacts?.find(data => data?.id === parseInt(tmpValue))?.id : null
          }
        } else {
          tmpCardInfo[column.name] = supplierDetails?.cardInfo?.[column.name] || null
        }
      } else if (column.datatype === 'boolean') {
        tmpCardInfo[column.name] = supplierDetails?.cardInfo?.[column.name] === null ? null : supplierDetails?.cardInfo?.[column.name]
      } else if (column.datatype === 'feetype') {
        tmpCardInfo[column.name] = supplierDetails?.cardInfo?.[column.name] || '$'
      } else {
        if (column.name === 'cardDiscountValue') {
          tmpCardInfo[column.name] = supplierDetails.cardInfo.cardDiscountType === 'Percentage' ? supplierDetails?.cardInfo[column.name]?.toString().match(/^\d{0,2}(\.\d{0,2})?/gi) ? supplierDetails?.cardInfo[column.name].toString().match(/^\d{0,2}(\.\d{0,2})?/gi)[0] : '' : supplierDetails?.cardInfo[column.name];
        } else if (multiSelectColumns.includes(column.name)) {
          let selectOptions = []
          const selectOptionsOptionsArray = supplierDetails?.cardInfo?.[column.name] ? supplierDetails?.cardInfo?.[column.name].split(',') : [];
          selectOptionsOptionsArray.map((option) => {
            option = option.replace(/^\s+|\s+$/g, "");
            selectOptions.push({
              label: (option[0].toUpperCase() + option.slice(1)).replaceAll('-', ' '),
              value: option
            })
          })
          tmpCardInfo[column.name] = selectOptions || []
        } else {
          tmpCardInfo[column.name] = supplierDetails?.cardInfo?.[column.name] || ''
        }
      }
    })

    var phoneNumber = !tmpCardInfo?.cardPaymentByPhoneValue ? '' : tmpCardInfo?.cardPaymentByPhoneValue;
    var ivrPhoneNumber = !tmpCardInfo?.cardPaymentIVRPhone ? '' : tmpCardInfo?.cardPaymentIVRPhone;
    await handlePhoneNumberFocusOut(null, null, phoneNumber, 'cardPaymentByPhoneValue')//, true, tmpCardInfo
    await handlePhoneNumberFocusOut(null, null, ivrPhoneNumber, 'cardPaymentIVRPhone')

    setSuppliercardInfo(tmpCardInfo)
    setAddEmailValues({});
    setRemoveEmailValues({});
    setCardAuthorizationFormFile(null);
    setSupplierOldCardInfo(supplierDetails)
    setAllContacts(supplierDetails?.contacts)
  }, [])

  useEffect(() => {
    if (isLoadingMasterDetail) {
      return
    }
    if ((!masterSupplierDetails || !masterSupplierDetails.cardInfo)) {
      return
    }

    if (!cardColumns) {
      return
    }

    setInitialCardInfo(cardColumns, masterSupplierDetails)
  }, [masterSupplierDetails, isLoadingMasterDetail, setInitialCardInfo])

  useEffect(async () => {
    if (Object.values(suppliercardInfo).length > 0) {
      await setPhoneAndEmailValues()
    }
  }, [Object.values(suppliercardInfo).length, masterSupplierDetails?.cardEmailsInfo?.length])

  const setPhoneAndEmailValues = async () => {
    const isEmailValid = async (email) => {
      var valid = await handleEmailFocusOut(email, false, true);
      return valid
    }

    const getEmails = async () => {
      var emailarray = []
      if (masterSupplierDetails?.cardEmailsInfo.length > 0) {
        let allAddedEmails = masterSupplierDetails?.cardEmailsInfo;
        emailarray = await Promise.all(
          allAddedEmails.map(async (item, ind) => {
            const email = item?.email && /^\d+$/.test(item?.email) ? masterSupplierDetails?.contacts?.find(data => data?.id === parseInt(item.email))?.email : item?.email || ''
            const emailContactId = item?.email && /^\d+$/.test(item?.email) ? masterSupplierDetails?.contacts?.find(data => data?.id === parseInt(item.email))?.id : null
            var index = 'extra-email-name-' + (ind + 1)
            // var emailValidOrRisky = await isEmailValid(item.email);
            var emailValidOrRisky = await isEmailValid(email);
            return {
              [index]: {
                'email': email, //item.email,
                'emailType': item.emailType,
                'valid': emailValidOrRisky?.valid,
                'risky': emailValidOrRisky?.risky,
                emailContactId: emailContactId
              }
            }
          })
        )
      }
      return emailarray
    };

    let emailValuesArray = await getEmails();
    setEmailValues(emailValuesArray);
    setEmailOldValues(emailValuesArray)
  }

  const handleToggleAmex = (checked) => {
    setSuppliercardInfo({
      ...suppliercardInfo,
      isAcceptAmericanExpress: checked,
    })
    setShowAmex(checked)
    onInfoChange(true)
  }
  const handleToggleVisa = (checked) => {
    setSuppliercardInfo({
      ...suppliercardInfo,
      isAcceptVisa: checked,
    })
    setShowVisa(checked)
    onInfoChange(true)
  }
  const handleToggleMaster = (checked) => {
    setSuppliercardInfo({
      ...suppliercardInfo,
      isAcceptMasterCard: checked,
    })
    setShowMaster(checked)
    onInfoChange(true)
  }

  const handleChangeCardInfo = (colname, value, type = null) => {
    var temp = "";
    temp = value ? parseInt(value.replace(/\D/g, '')) : '';
    value = temp ? ((temp) / 100).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : '';
    if (type === 'currency') {
      if (/^(\d+)((\,)(\d+))*((\,))*(\.\d{0,2})?$/.test(value)) {
        setSuppliercardInfo({
          ...suppliercardInfo,
          [colname]: value
        })
      } else {
        setSuppliercardInfo({
          ...suppliercardInfo,
          [colname]: value.match(/^(\d+)((\,)(\d+))*((\,))*(\.\d{0,2})?$/gi) ? value.match(/^(\d+)((\,)(\d+))*((\,))*(\.\d{0,2})?$/gi)[0] : ''
        })
      }
      onInfoChange(true)
      return
    }
    if (type === 'percent') {
      if (/^\d{0,2}(\.\d{0,2})?$/.test(value)) {
        setSuppliercardInfo({
          ...suppliercardInfo,
          [colname]: value
        })
      } else {
        setSuppliercardInfo({
          ...suppliercardInfo,
          [colname]: value.match(/^\d{0,2}(\.\d{0,2})?/gi) ? value.match(/^\d{0,2}(\.\d{0,2})?/gi)[0] : ''
        })
      }
      onInfoChange(true)
      return
    }
    setSuppliercardInfo({
      ...suppliercardInfo,
      [colname]: value
    })
    onInfoChange(true)
  }

  const handleClickCancel = async () => {
    await setInitialCardInfo(cardColumns, masterSupplierDetails)
    setEmailValues(emailOldValues)
    setSuppliercardEmailsInfo({})
    setCardEmailType('')
  }

  const handleSave = async () => {
    setIsLoading(true)
    var invalidEmail = false

    if (isValidatingPhone || isValidatingIVRPhone) {
      toast.show({
        title: 'Warning',
        description: 'validating phone number...!',
        duration: 3000
      })
      setIsLoading(false)
      return
    }

    if (suppliercardInfo?.isAcceptCardPaymentByFax && !suppliercardInfo?.cardPaymentByFaxValue) {
      toast.show({
        title: 'Danger',
        description: 'Cannot save fax acceptance without a valid fax!',
      })
      setIsLoading(false)
      return
    }

    if (suppliercardInfo?.isAcceptCardPaymentByPhone) {
      if ((!suppliercardInfo?.isAcceptPOTSPhone && !suppliercardInfo?.isAcceptIVRPhone) || (suppliercardInfo?.isAcceptPOTSPhone && (!suppliercardInfo?.cardPaymentByPhoneValue || countryCode === suppliercardInfo?.cardPaymentByPhoneValue))) {
        toast.show({
          title: 'Danger',
          description: 'Cannot save phone acceptance without a valid phone!',
        })
        setIsLoading(false)
        return
      }
      if (suppliercardInfo?.isAcceptIVRPhone && (!suppliercardInfo?.cardPaymentIVRPhone || ivrCountryCode === suppliercardInfo?.cardPaymentIVRPhone)) {
        toast.show({
          title: 'Danger',
          description: 'Cannot save IVR phone acceptance without a valid phone!',
        })
        setIsLoading(false)
        return
      }
    }

    if (suppliercardInfo?.isAcceptCardPaymentByOnlinePortal && ((suppliercardInfo?.isAcceptPortal && !suppliercardInfo?.portalUrl) || (suppliercardInfo?.isAccept3rdPartyPortal && !suppliercardInfo?.thirdPartyPortalUrl))) {
      setIsLoading(false)
      toast.show({
        title: 'Danger',
        description: 'Cannot save online acceptance without a valid website!',
      })
      return
    }

    var invalidEmail = false
    if (suppliercardEmailsInfo?.[0]?.email && suppliercardEmailsInfo?.[0]?.email !== undefined) {
      if (!isEmailValid && isEmailValid !== '') {
        setIsLoading(false)
        toast.show({
          title: 'Warning',
          description: 'Invalid Email'
        })
        return
      }
      if (cardEmailType === '') {
        setIsLoading(false)
        toast.show({
          title: 'Warning',
          description: 'Please choose the Email Type from dropdown!',
        })
        return
      }
      addEmailValues[Object.keys(addEmailValues).length] = {
        'email': suppliercardEmailsInfo?.[0]?.email,
        'emailType': cardEmailType,
        emailContactId: suppliercardEmailsInfo?.[0]?.emailContactId
      }
      setSuppliercardEmailsInfo({})
      setCardEmailType('')
    } else {
      if (suppliercardInfo?.isAcceptCardPaymentByEmail && emailValues.filter(x => x).length === 0) {
        toast.show({
          title: 'Danger',
          description: 'Cannot save email acceptance without a valid email!',
        })
        setIsLoading(false)
        return
      }
    }

    const hasDuplicateEmails = findDuplicateEmails(addEmailValues)

    if (isPhoneValid === false) {
      toast.show({
        title: 'Warning',
        description: 'Invalid Phone Number!',
      })
      setIsLoading(false)
      return
    }

    if (!isFaxValid) {
      toast.show({
        title: 'Warning',
        description: 'Invalid Fax Number!',
      })
      setIsLoading(false)
      return
    }

    if (!isThirdPartyPortalUrlValid) {
      toast.show({
        title: 'Warning',
        description: 'Invalid Third Party Portal URL!',
      })
      setIsLoading(false)
      return
    }

    if (!isPortalUrlValid) {
      toast.show({
        title: 'Warning',
        description: 'Invalid Portal URL!',
      })
      setIsLoading(false)
      return
    }

    if (isIVRPhoneValid === false) {
      toast.show({
        title: 'Warning',
        description: 'Invalid IVR Phone Number!',
      })
      setIsLoading(false)
      return
    }

    if (hasDuplicateEmails?.isDuplicateEmail) {
      toast.show({
        title: 'Warning',
        description: 'Please add unique emails. You have added duplicate emails',
      })
      setIsLoading(false)
      setAddEmailValues(hasDuplicateEmails?.addedEmails)
      return
    }

    if (suppliercardInfo?.isAcceptAmexCardConditions || suppliercardInfo?.isAcceptVisaCardConditions || suppliercardInfo?.isAcceptMastercardCardConditions) {
      if (suppliercardInfo?.isAcceptAmexCardConditions) {
        const isAmexCardConditions = checkAmexCardConditonsAdded(suppliercardInfo)
        if (!isAmexCardConditions) {
          toast.show({
            title: 'Warning',
            description: 'Please add Amex Card Conditions!',
          })
          setIsLoading(false)
          return
        }
      }
      if (suppliercardInfo?.isAcceptVisaCardConditions) {
        const isVisaCardConditions = checkVisaCardConditonsAdded(suppliercardInfo)
        if (!isVisaCardConditions) {
          toast.show({
            title: 'Warning',
            description: 'Please add Visa Card Conditions!',
          })
          setIsLoading(false)
          return
        }
      }
      if (suppliercardInfo?.isAcceptMastercardCardConditions) {
        const isMasterCardConditions = checkMasterCardConditonsAdded(suppliercardInfo)
        if (!isMasterCardConditions) {
          toast.show({
            title: 'Warning',
            description: 'Please add Master Card Conditions!',
          })
          setIsLoading(false)
          return
        }
      }
    }

    if (countryCode === suppliercardInfo?.cardPaymentByPhoneValue) {
      suppliercardInfo['cardPaymentByPhoneValue'] = ''
      suppliercardInfo.phoneContactId = null
    }
    if (ivrCountryCode === suppliercardInfo?.cardPaymentIVRPhone) {
      suppliercardInfo['cardPaymentIVRPhone'] = ''
      suppliercardInfo.ivrPhoneContactId = null
    }

    const tmpSupplierInfo = JSON?.parse(JSON?.stringify(suppliercardInfo))
    const cardProductSpecificOptions = tmpSupplierInfo?.productSpecificOptions ? tmpSupplierInfo?.productSpecificOptions?.map(option => option?.value)?.join(",") : ''
    tmpSupplierInfo['productSpecificOptions'] = cardProductSpecificOptions
    tmpSupplierInfo['emailRemitRequirements'] = tmpSupplierInfo?.emailRemitRequirements ? tmpSupplierInfo?.emailRemitRequirements?.map(option => option?.value)?.join(",") : ''
    tmpSupplierInfo['phoneRemitRequirements'] = tmpSupplierInfo?.phoneRemitRequirements ? tmpSupplierInfo?.phoneRemitRequirements?.map(option => option?.value)?.join(",") : ''
    tmpSupplierInfo['faxRemitRequirements'] = tmpSupplierInfo?.faxRemitRequirements ? tmpSupplierInfo?.faxRemitRequirements?.map(option => option?.value)?.join(",") : ''
    tmpSupplierInfo['onlineRemitRequirements'] = tmpSupplierInfo?.onlineRemitRequirements ? tmpSupplierInfo?.onlineRemitRequirements?.map(option => option?.value)?.join(",") : ''
    tmpSupplierInfo['posRemitRequirements'] = tmpSupplierInfo?.posRemitRequirements ? tmpSupplierInfo?.posRemitRequirements?.map(option => option?.value)?.join(",") : ''

    let isCardAcceptanceUpdated = isDiffTwoObj(tmpSupplierInfo, supplierOldCardInfo?.cardInfo)
    let isAcceptanceGotUpdatedForSpecificFields = onSupplierCardAccUpdate(tmpSupplierInfo, supplierOldCardInfo?.cardInfo, removeEmailValues, addEmailValues, suppliercardEmailsInfo)

    if (Object.keys(removeEmailValues).length > 0) {
      isCardAcceptanceUpdated = true
      await dispatch(
        await removeCardAcceptanceEmails({
          supplierId: masterSupplierDetails?.cardInfo?.supplierId,
          removeEmailsData: {
            removeEmailValues
          },
        })
      ).then(() => {
        toast.show({
          title: 'Success',
          description: 'Sucessufully removed card acceptance emails',
        })
        setIsLoading(false)
      }).catch(() => {
        toast.show({
          title: 'Warning',
          description: 'Failed to remove card acceptance emails',
        })
        setIsLoading(false)
      })
    }

    // if there is uploaded file for card Authorization Form
    if (cardAuthorizationFormFile && cardAuthorizationFormFile.name) {
      await dispatch(
        await uploadCardAuthorizationFormFile(cardAuthorizationFormFile)
      ).then(async (response) => {
        toast.show({
          title: 'Success',
          description: response.data.message,
        })
        tmpSupplierInfo.cardAuthorizationFormFile = response.data.generatename

        await dispatchEmailsData(addEmailValues, invalidEmail, masterSupplierDetails, tmpSupplierInfo, isCardAcceptanceUpdated, isAcceptanceGotUpdatedForSpecificFields)
        setIsLoading(false)
      }).catch((err) => {
        toast.show({
          title: 'Warning',
          description: "Unable to Upload Card Authorization File",
        })
        setIsLoading(false)
      })
    } else {
      await dispatchEmailsData(addEmailValues, invalidEmail, masterSupplierDetails, tmpSupplierInfo, isCardAcceptanceUpdated, isAcceptanceGotUpdatedForSpecificFields)
      setIsLoading(false)
    }
  }

  const handleFileChosen = (file) => {
    if (
      !file
    ) {
      return
    }
    setCardAuthorizationFormFile(file)
    onInfoChange(true)
  }

  const handleChangeReceivePaymentInfo = (colname, colvalue, value) => {
    let tmpValue = value
    if (colname === 'url') {
      if (value === '' || /(https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|www\.[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9]+\.[^\s]{2,}|www\.[a-zA-Z0-9]+\.[^\s]{2,})/i.test(value)) {
        if (colvalue === 'thirdPartyPortalUrl') {
          setIsThirdPartyPortalUrlValid(true)
        } else {
          setIsPortalUrlValid(true)
        }
      } else {
        if (colvalue === 'thirdPartyPortalUrl') {
          setIsThirdPartyPortalUrlValid(false)
        } else {
          setIsPortalUrlValid(false)
        }
      }
    } else if (colname === 'extension') {
      if (/^\d{20}$/.test(value)) {
        setSuppliercardInfo({
          ...suppliercardInfo,
          [colvalue]: value
        })
      } else {
        setSuppliercardInfo({
          ...suppliercardInfo,
          [colvalue]: value.match(/^\d{1,20}/gi) ? value.match(/^\d{1,20}/gi)[0] : ''
        })
      }
      onInfoChange(true)
      return
    } else {
      if (value === '' || /^([+]?[\s0-9]{2,4})?(\d{1,}|[(]?[0-9]+[)])?([-]?[\s]?[0-9]){10}$/i.test(value)) {
        setIsFaxValid(true)
      } else {
        setIsFaxValid(false)
      }
    }

    setReceivePaymentInfo({
      ...receivePaymentInfo,
      [colvalue]: value === '' ? '' : tmpValue
    })
    setSuppliercardInfo({
      ...suppliercardInfo,
      [colvalue]: value === '' ? '' : tmpValue
    })
    onInfoChange(true)
  }

  const handleReceivePaymentCheckbox = (colname) => {
    setSuppliercardInfo({
      ...suppliercardInfo,
      [colname]: suppliercardInfo?.[colname] ? false : true
    })
    onInfoChange(true)
  }

  const handleTogglePaymentTerms = (checked) => {
    setSuppliercardInfo({
      ...suppliercardInfo,
      isAcceptCardPaymentTerms: checked
    })
    setShowCardPaymentTerms(checked)
    onInfoChange(true)
  }

  const handleToggleCardDiscount = (checked) => {
    setSuppliercardInfo({
      ...suppliercardInfo,
      isAcceptCardDiscount: checked
    })
    setShowCardDiscount(checked)
    onInfoChange(true)
  }

  const handleCardAuthorizationFormChange = (value) => {
    setSuppliercardInfo({
      ...suppliercardInfo,
      tokenType: value,
    })
    setTokenConfigurationValue(value)
    onInfoChange(true)
  }

  const handleChangeCardDiscountType = (value) => {
    var discountValue = ''
    discountValue = value?.value === 'Percentage' ? suppliercardInfo?.cardDiscountValue && suppliercardInfo?.cardDiscountValue?.toString().match(/^\d{0,2}(\.\d{0,2})?/gi) ?
      parseInt(suppliercardInfo?.cardDiscountValue.replace(",", "").toString().match(/^\d{0,2}(\.\d{0,2})?/gi)[0]).toFixed(2)
      : ''
      : suppliercardInfo?.cardDiscountValue
    setSuppliercardInfo({
      ...suppliercardInfo,
      cardDiscountType: value?.value,
      cardDiscountValue: discountValue
    })
    setCardDiscountType(value)
    onInfoChange(true)
  }

  const handleChangeCardPaymentTerms = (value) => {
    if (value.length === 0) {
      setSuppliercardInfo({
        ...suppliercardInfo,
        cardPaymentTermsvalue: '',
      })
      setpaymentTermValue('')
      onInfoChange(true)
      return
    }
    setSuppliercardInfo({
      ...suppliercardInfo,
      cardPaymentTermsvalue: value,
    })
    setpaymentTermValue(value)
    onInfoChange(true)
  }

  const handleChangeCardDiscountValue = (value, type) => {
    var temp = "";
    temp = value ? parseInt(value.replace(/\D/g, '')) : '';
    temp = isNaN(temp) ? '' : temp
    value = temp ? ((temp) / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",") : '';
    if (type === 'percent') {
      if (/^\d{0,2}(\.\d{0,2})?$/.test(value)) {
        setSuppliercardInfo({
          ...suppliercardInfo,
          cardDiscountValue: value
        })
      } else {
        setSuppliercardInfo({
          ...suppliercardInfo,
          cardDiscountValue: value.match(/^\d{0,2}(\.\d{0,2})?/gi) ? value.match(/^\d{0,2}(\.\d{0,2})?/gi)[0] : ''
        })
      }
      onInfoChange(true)
      return
    }
    setSuppliercardInfo({
      ...suppliercardInfo,
      cardDiscountValue: value,
    })
    setCardDiscountValue(value)
    onInfoChange(true)
  }

  const addMoreEmail = async () => {
    if (Object.keys(suppliercardEmailsInfo).length > 0) {
      if (suppliercardEmailsInfo?.[0]?.email && suppliercardEmailsInfo?.[0]?.email !== '' && !/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,})+$/.test(suppliercardEmailsInfo?.[0]?.email)) {
        toast.show({
          title: 'Warning',
          description: 'Email Address must be in email format',
        })
        return
      }
      if (cardEmailType === '') {
        toast.show({
          title: 'Warning',
          description: 'Please choose the Email Type from dropdown!',
        })
        return
      }


      var addEmailValuesObject = {}
      if (Object.keys(emailValues).length > 0) {
        Object.keys(emailValues).map((key, index) => {
          addEmailValuesObject[key] = emailValues?.[key]?.['extra-email-name-' + (index + 1)]?.email
        })
      }

      if (Object.values(addEmailValuesObject)?.includes(suppliercardEmailsInfo?.[0]?.email)) {
        toast.show({
          title: 'Warning',
          description: 'Email Address is already added!',
        })
        return
      }

      var isValidEmail = await handleEmailFocusOut(suppliercardEmailsInfo?.[0]?.email, false, true)
      if (isValidEmail?.valid) {
        var index = 'extra-email-name-' + (emailValues.length + 1)
        var index1 = Object.keys(addEmailValues).length
        setEmailValues([...emailValues, { [index]: { 'email': suppliercardEmailsInfo?.[0]?.email, 'emailType': cardEmailType, 'valid': isEmailValid, emailContactId: suppliercardEmailsInfo?.[0]?.emailContactId } }]);
        setAddEmailValues({ ...addEmailValues, [index1]: { 'email': suppliercardEmailsInfo?.[0]?.email, 'emailType': cardEmailType, 'valid': isEmailValid, emailContactId: suppliercardEmailsInfo?.[0]?.emailContactId } })
        setSuppliercardEmailsInfo({})
        setCardEmailType('')
      }
    } else {
      toast.show({
        title: 'Warning',
        description: 'Please add Email Address',
      })
      return
    }
  };

  const removeEmail = (index) => {
    let data = [...emailValues];
    let addedEmailsData = addEmailValues;
    let isEmailExists = masterSupplierDetails?.cardEmailsInfo.find(item => (parseInt(item?.email) === parseInt(data[index - 1]['extra-email-name-' + index]?.emailContactId)) || (item?.email === data[index - 1]['extra-email-name-' + index]?.email));
    if (isEmailExists) {
      // setRemoveEmailValues({ ...removeEmailValues, [Object.keys(removeEmailValues).length]: data[index - 1]['extra-email-name-' + index]?.emailContactId })
      setRemoveEmailValues({ ...removeEmailValues, [Object.keys(removeEmailValues).length]: isEmailExists?.email })
    }
    delete data[index - 1]
    setEmailValues(data)
    delete addedEmailsData[index - 1]
    setAddEmailValues(addedEmailsData)
    onInfoChange(true)
  }

  const handleEmailsChange = (event, index = '') => {
    let isEmailExists
    var oldValue = event.currentTarget._wrapperState.initialValue
    if (index !== 0) {
      let newFormValues = [...emailValues];
      isEmailExists = masterSupplierDetails?.cardEmailsInfo.find(item => item.email === oldValue);
      newFormValues[index - 1][event.target.name]['email'] = event.target.value;
      setEmailValues(newFormValues);
      if (!isEmailExists) {
        let addEmailFormValues = addEmailValues;
        addEmailFormValues[index - 1]['email'] = event.target.value;
        setAddEmailValues(addEmailFormValues)
      }
    } else {
      if (!event.target.value) {
        setIsEmailValid(true)
      } else {
        setIsEmailValid(false)
      }
    }
    setSuppliercardEmailsInfo({
      ...suppliercardEmailsInfo, [index]: {
        email: event.target.value,
        emailContactId: null
      }
    })
    onInfoChange(true)
  }
  const dispatchEmailsData = async (addEmailValues, invalidEmail, masterSupplierDetails, tmpSupplierInfo, isCardAcceptanceUpdated, isAcceptanceGotUpdatedForSpecificFields) => {
    // if (tmpSupplierInfo?.ivrPhoneContactId) {
    //   tmpSupplierInfo.cardPaymentIVRPhone = tmpSupplierInfo.ivrPhoneContactId
    // }
    // if (tmpSupplierInfo?.phoneContactId) {
    //   tmpSupplierInfo.cardPaymentByPhoneValue = tmpSupplierInfo.phoneContactId
    // }
    if (Object.keys(addEmailValues).length > 0) {
      Object.keys(addEmailValues).map((key, index) => {
        if (addEmailValues[key] &&
          addEmailValues[key]?.email !== '' &&
          !/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,})+$/.test(addEmailValues[key]?.email)
          // validator.validate(addEmailValues[key]?.email)
        ) {
          invalidEmail = true
          delete addEmailValues[key]
          return
        }
      })
      // return

      if (!invalidEmail) {
        isCardAcceptanceUpdated = true
        await dispatch(
          await addCardAcceptanceEmails({
            supplierId: masterSupplierDetails?.baseInfo?.id,
            userId: masterSupplierDetails?.baseInfo?.userId,
            cardEmailsData: {
              addEmailValues
            }
          })
        ).then(async () => {
          await dispatch(
            await updateSupplierCardInfo({
              masterSupplierId,
              cardId: masterSupplierDetails?.cardInfo?.id,
              cardData: {
                ...masterSupplierDetails?.cardInfo,
                ...tmpSupplierInfo,
              },
              feeData: deliveryMethodFeeValues,
              isCardAcceptanceUpdated,
              isAcceptanceGotUpdatedForSpecificFields
            })
          ).then(async (result) => {
            onGetAllContactsData()
            await addCardAcceptanceHistory(tmpSupplierInfo)
            onUpdateCompletenessScore(masterSupplierDetails?.baseInfo?.id)
            onInfoChange(false)
          })
        })
      } else {
        toast.show({
          title: 'Warning',
          description: 'Email Address must be in email format',
        })
      }
    } else {
      await dispatch(
        await updateSupplierCardInfo({
          masterSupplierId,
          cardId: masterSupplierDetails?.cardInfo?.id,
          cardData: {
            ...masterSupplierDetails?.cardInfo,
            ...tmpSupplierInfo,
          },
          feeData: deliveryMethodFeeValues,
          isCardAcceptanceUpdated,
          isAcceptanceGotUpdatedForSpecificFields
        })
      ).then(async (result) => {
        onGetAllContactsData()
        await addCardAcceptanceHistory(tmpSupplierInfo)
        onUpdateCompletenessScore(masterSupplierDetails?.baseInfo?.id)
        onInfoChange(false)
      }).catch(err => {
         toast.show({
          title: 'Warning',
          description: 'Error While Updating Supplier Card Info',
        })
      })
    }
  }

  const addCardAcceptanceHistory = async (tmpSupplierInfo) => {
    var addEmailValuesObject = {}
    if (Object.keys(addEmailValues).length > 0) {
      Object.keys(addEmailValues).map((key, index) => {
        addEmailValuesObject[key] = addEmailValues[key]?.email
      })
    }

    const tmpSupplierOldCardInfo = { ...supplierOldCardInfo }
    tmpSupplierOldCardInfo.cardInfo.cardPaymentByPhoneValue = /^\d+$/.test(tmpSupplierOldCardInfo?.cardInfo?.cardPaymentByPhoneValue) && !/^(\d{1,}|[(]?[0-9]+[)])?([-]?[\s]?[0-9]){10}$/i.test(tmpSupplierOldCardInfo?.cardInfo?.cardPaymentByPhoneValue) ? tmpSupplierOldCardInfo?.contacts?.find(data => data?.id === parseInt(tmpSupplierOldCardInfo?.cardInfo?.cardPaymentByPhoneValue))?.phone : (tmpSupplierOldCardInfo?.cardInfo?.cardPaymentByPhoneValue || '')
    tmpSupplierOldCardInfo.cardInfo.cardPaymentIVRPhone = /^\d+$/.test(tmpSupplierOldCardInfo?.cardInfo?.cardPaymentIVRPhone) && !/^(\d{1,}|[(]?[0-9]+[)])?([-]?[\s]?[0-9]){10}$/i.test(tmpSupplierOldCardInfo?.cardInfo?.cardPaymentIVRPhone) ? tmpSupplierOldCardInfo?.contacts?.find(data => data?.id === parseInt(tmpSupplierOldCardInfo?.cardInfo?.cardPaymentIVRPhone))?.phone : (tmpSupplierOldCardInfo?.cardInfo?.cardPaymentIVRPhone || '')
    const changeLogNotes = generateCardAcceptanceChangeLog(tmpSupplierOldCardInfo, tmpSupplierInfo, addEmailValuesObject, removeEmailValues);
    if (changeLogNotes !== '') {
      await dispatch(
        await addSupplierHistory({
          supplierId: masterSupplierDetails?.baseInfo?.id,
          note: changeLogNotes,
          noteType: 'changelog'
        })
      )
    }
  }

  const handleChangeCardEmailType = (value) => {
    setCardEmailType(value)
  }

  const handlePhoneNumberFocusOut = async (event, country, phoneValue, colName) => {
    var countryCode = country && country.dialCode
    var phoneValueWithCode = phoneValue
    var testPhone = phoneValue.replace(/^\s*(?:\+?(\d{1,4})\s)?/, '').replace(/[^\w\s]|[\s]/gi, '')
    if (testPhone !== '' && testPhone !== countryCode && !/^(\d{1,}|[(]?[0-9]+[)])?([-]?[\s]?[0-9]){10}$/i.test(testPhone)) {
      colName === 'cardPaymentByPhoneValue' ? setIsPhoneValid(false) : setIsIVRPhoneValid(false)
      toast.show({
        title: 'Warning',
        description: 'Please enter valid phone number!'
      })
      return
    }

    if ((event && event.type === 'blur' && event.relatedTarget !== null && event.relatedTarget.classList.value === 'selected-flag') || (countryCode === phoneValueWithCode.replace(/^\s*(?:\+)/, ''))) {
      return
    }
    if (phoneValue !== '') {
      colName === 'cardPaymentByPhoneValue' ? setIsValidatingPhone(true) : setIsValidatingIVRPhone(true)
      phoneValue = phoneValue.replace(/^\s*(?:\+?(\d{1,4})\s)?/, '').replace(/[^\w\s]|[\s]/gi, '')
      var phoneValidationResult = await checkIsPhoneNumberValid(phoneValue, phoneValueWithCode, dispatch)
      colName === 'cardPaymentByPhoneValue' ? setIsPhoneValid(phoneValidationResult?.isPhoneValid) : setIsIVRPhoneValid(phoneValidationResult?.isPhoneValid)
      colName === 'cardPaymentByPhoneValue' ? setIsValidatingPhone(phoneValidationResult?.isValidatingPhone) : setIsValidatingIVRPhone(phoneValidationResult?.isValidatingPhone)
    } else {
      colName === 'cardPaymentByPhoneValue' ? setIsPhoneValid(true) : setIsIVRPhoneValid(true)
    }
  }

  const handlePhoneInputChange = (value, country, e, formattedValue, colName) => {
    if (value !== '') {
      colName === 'cardPaymentByPhoneValue' ? setIsPhoneValid(false) : setIsIVRPhoneValid(false)
    } else {
      colName === 'cardPaymentByPhoneValue' ? setIsPhoneValid(true) : setIsIVRPhoneValid(true)
    }
    setSuppliercardInfo({
      ...suppliercardInfo,
      [colName]: value === '' ? '' : value
    })
    onInfoChange(true)
  }

  const handleEmailFocusOut = async (emailValue, isInitialCall = false, isAddingEmail = true, emailObj = {}, isRetry = false) => {
    if (emailValue &&
      emailValue !== '' &&
      !/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,})+$/.test(emailValue)
    ) {
      setIsEmailValid(false)
      toast.show({
        title: 'Warning',
        description: 'Email Address must be in email format!'
      })
      return
    }
    var valid = true;
    let risky = false;
    if (emailValue && emailValue !== '') {
      setIsValidatingEmail(true)
      var emailValidationResult = await checkIsEmailValid(emailValue, dispatch, isRetry)
      valid = emailValidationResult?.isEmailValid;
      risky = emailValidationResult?.isEmailRisky;
      setIsEmailValid(emailValidationResult?.isEmailValid)
      setIsValidatingEmail(emailValidationResult?.isValidatingEmail)
      setIsEmailRisky(emailValidationResult?.isEmailRisky)
    } else {
      setIsEmailValid(true)
    }

    if (isInitialCall) {
      var index = 'extra-email-name-' + (emailValues.length + 1)
      emailValues.push({ [index]: { 'email': emailValue, 'emailType': emailObj?.emailType, 'valid': valid } })
      return emailValues
    }
    if (isAddingEmail) {
      return { valid, risky }
    }
  }

  const handleKeyDown = (e, phoneInputRefname) => {
    if (e.keyCode === 9) {
      phoneInputRefname.current.props.onBlur()
    }
  }

  const handleCloseAdvanceAccDetailsModal = () => {
    setShowAdvanceAccDetailsModal(false)
    setDeliveryMethodValues({
      email: false,
      phone: false,
      fax: false,
      online: false,
      pos: false,
    })
  }

  const handleDeliveryMethodsChange = (checked, name) => {
    setDeliveryMethodValues({ ...deliveryMethodValues, [name]: checked })
  }

  // const setDeliveryMethodsFeeValues = (emailFeeInfo, phoneFeeInfo, faxFeeInfo, onlineFeeInfo, posFeeInfo) => {
  const setDeliveryMethodsFeeValues = (feeSettings, selectedOptions) => {
    if (!feeSettings?.['isAcceptAmericanExpress'] && !feeSettings?.['isAcceptVisa'] && !feeSettings?.['isAcceptMasterCard']) {
      toast.show({
        title: 'Warning',
        description: 'Please select atleast one Card Acceptance!',
      })
      return
    }
    var feeInfo = deliveryMethodFeeValues
    selectedOptions.map((option) => {
      feeInfo = {
        ...feeInfo,
        [option]: feeSettings
      }
    })
    setDeliveryMethodFeeValues(feeInfo)
    setCardFeeInfo(defaultCardFeeInfo)
    setSuppliercardInfo({
      ...suppliercardInfo,
      'advancedAcceptanceEnabled': true
    })

    setDeliveryMethodValues(
      {
        email: false,
        phone: false,
        fax: false,
        online: false,
        pos: false,
      }
    )
    onInfoChange(true)
  }

  const handleUpdateCardFeeInfo = (colName, value, type = 'showHideFee', feeValueColumnName, feeValueType) => {
    var feeValue = ''
    if (type === 'showHideFee') {
      setCardFeeInfo({ ...cardFeeInfo, 'showHideFee': { ...cardFeeInfo?.showHideFee, [colName]: value } })
    } else {
      if (value?.value !== '$' && value?.value !== '%') {
        var temp = "";
        temp = parseInt(value.replace(/\D/g, ''));
        value = temp ? ((temp) / 100).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : '';
        if (feeValueType === '$') {
          if (! /^(\d+)((\,)(\d+))*((\,))*(\.\d{0,2})?$/.test(value)) {
            value = value?.match(/^(\d+)((\,)(\d+))*((\,))*(\.\d{0,2})?$/gi) ? value.match(/^(\d+)((\,)(\d+))*((\,))*(\.\d{0,2})?$/gi)[0] : ''
          }
        } else {
          if (! /^\d{0,2}(\.\d{0,2})?$/.test(value)) {
            value = value?.match(/^\d{0,2}(\.\d{0,2})?/gi) ? value.match(/^\d{0,2}(\.\d{0,2})?/gi)[0] : ''
          }
        }
        setCardFeeInfo({ ...cardFeeInfo, 'feeValues': { ...cardFeeInfo?.feeValues, [colName]: value } })
      } else {
        feeValue = value?.value === '%' ? suppliercardInfo?.[feeValueColumnName] && suppliercardInfo?.[feeValueColumnName]?.toString().match(/^\d{0,2}(\.\d{0,2})?/gi) ?
          parseInt(suppliercardInfo?.[feeValueColumnName].replace(',', '').match(/^\d{0,2}(\.\d{0,2})?/gi)[0]).toFixed(2)
          : ''
          : suppliercardInfo?.[feeValueColumnName]

        setSuppliercardInfo({
          ...suppliercardInfo,
          [feeValueColumnName]: feeValue,
          [colName]: value?.value
        })
      }
      onInfoChange(true)
    }
  }

  const handleToggleDisableAdvancedAcceptance = (checked) => {
    setSuppliercardInfo({
      ...suppliercardInfo,
      advancedAcceptanceEnabled: checked,
    })
    onInfoChange(true)
  }

  const handleChangeGenericFeeInfo = (colname, value, cardColumnsArray = [], feeValueColumnName, cardFeeColumnsArray = [], type = null) => {
    let conditionColumns = [
      { name: 'processingFeeType', value: '$' },
      { name: 'processingFeeValue', value: '' },
      { name: 'processingSecondFeeType', value: '$' },
      { name: 'processingSecondFeeValue', value: '' },
      { name: 'minFeeType', value: '$' },
      { name: 'minFeeValue', value: '' },
      { name: 'maxFeeType', value: '$' },
      { name: 'maxFeeValue', value: '' },
      { name: 'incrementalFeeType', value: '$' },
      { name: 'incrementalFeeValue', value: '' },
      { name: 'minPayment', value: '' },
      { name: 'maxPayment', value: '' },
      { name: 'incrementalPayment', value: '' },
      { name: 'showVariableFee', value: null },
      { name: 'showMinFee', value: false },
      { name: 'showMaxFee', value: false },
      { name: 'showIncrementalFee', value: false }
    ]

    let tmpCardInfo = { ...suppliercardInfo }
    var feeValue = ''
    if (type === 'currency' || type === 'percent') {
      var temp = "";
      temp = value ? parseInt(value.replace(/\D/g, '')) : '';
      value = temp ? ((temp) / 100).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : '';
      if (type === 'currency') {
        if (/^(\d+)((\,)(\d+))*((\,))*(\.\d{0,2})?$/.test(value)) {
          value = value
        } else {
          value = value.match(/^(\d+)((\,)(\d+))*((\,))*(\.\d{0,2})?$/gi) ? value.match(/^(\d+)((\,)(\d+))*((\,))*(\.\d{0,2})?$/gi)[0] : ''
        }
      }
      if (type === 'percent') {
        if (/^\d{0,2}(\.\d{0,2})?$/.test(value)) {
          value = value
        } else {
          value = value.match(/^\d{0,2}(\.\d{0,2})?/gi) ? value.match(/^\d{0,2}(\.\d{0,2})?/gi)[0] : ''
        }
      }
    }

    if (value === '$' || value === '%') {
      feeValue = value === '%' ? genericFeeValues?.[feeValueColumnName] && genericFeeValues?.[feeValueColumnName]?.toString().match(/^\d{0,2}(\.\d{0,2})?/gi) ?
        parseInt(genericFeeValues?.[feeValueColumnName].replace(',', '').match(/^\d{0,2}(\.\d{0,2})?/gi)[0]).toFixed(2)
        : ''
        : genericFeeValues?.[feeValueColumnName]
      setGenericFeeValues({
        ...genericFeeValues,
        [colname]: value,
        [feeValueColumnName]: feeValue
      })

      cardFeeColumnsArray.map((cardFeeColumn) => {
        tmpCardInfo = {
          ...tmpCardInfo,
          [cardFeeColumn]: feeValue
        }
      })
    } else {
      let tmpGenericFeeValues = { ...genericFeeValues }
      tmpGenericFeeValues[colname] = value
      if (colname === 'showCardConditions' && !value) {
        conditionColumns.forEach(column => {
          tmpGenericFeeValues = {
            ...tmpGenericFeeValues,
            [column.name]: column.value
          }
        })
        setShowAnotherProcessingFee(false)
      }
      setGenericFeeValues(tmpGenericFeeValues)
      if (type === 'showHideFee') {
        return
      }
    }

    cardColumnsArray.map((cardColumn) => {
      tmpCardInfo = {
        ...tmpCardInfo,
        [cardColumn]: value
      }
    })

    if (colname === 'showCardConditions' && !value) {
      const columns = [
        { name: 'amexProcessingFeeType', value: '$' },
        { name: 'amexProcessingFeeValue', value: '' },
        { name: 'amexSecondProcessingFeeType', value: '$' },
        { name: 'amexSecondProcessingFeeValue', value: '' },
        { name: 'amexMinPaymentFeeType', value: '$' },
        { name: 'amexMinPaymentFeeValue', value: '' },
        { name: 'amexMaxPaymentFeeType', value: '$' },
        { name: 'amexMaxPaymentFeeValue', value: '' },
        { name: 'amexIncrementalFeeType', value: '$' },
        { name: 'amexIncrementalFeeValue', value: '' },
        { name: 'amexIncrementalPaymentAmount', value: '' },
        { name: 'americanExpressMinPaymnet', value: '' },
        { name: 'americanExpressMaxPayment', value: '' },
        { name: 'isAcceptAmexVariableFee', value: null },
        { name: 'visaProcessingFeeType', value: '$' },
        { name: 'visaProcessingFeeValue', value: '' },
        { name: 'visaSecondProcessingFeeType', value: '$' },
        { name: 'visaSecondProcessingFeeValue', value: '' },
        { name: 'visaMinPaymentFeeType', value: '$' },
        { name: 'visaMinPaymentFeeValue', value: '' },
        { name: 'visaMaxPaymentFeeType', value: '$' },
        { name: 'visaMaxPaymentFeeValue', value: '' },
        { name: 'visaIncrementalFeeType', value: '$' },
        { name: 'visaIncrementalFeeValue', value: '' },
        { name: 'visaIncrementalPaymentAmount', value: '' },
        { name: 'visaMinPayment', value: '' },
        { name: 'visaMaxPayment', value: '' },
        { name: 'isAcceptVisaVariableFee', value: null },
        { name: 'mastercardProcessingFeeType', value: '$' },
        { name: 'mastercardProcessingFeeValue', value: '' },
        { name: 'mastercardSecondProcessingFeeType', value: '$' },
        { name: 'mastercardSecondProcessingFeeValue', value: '' },
        { name: 'mastercardMinPaymentFeeType', value: '$' },
        { name: 'mastercardMinPaymentFeeValue', value: '' },
        { name: 'mastercardMaxPaymentFeeType', value: '$' },
        { name: 'mastercardMaxPaymentFeeValue', value: '' },
        { name: 'mastercardIncrementalFeeType', value: '$' },
        { name: 'mastercardIncrementalFeeValue', value: '' },
        { name: 'mastercardIncrementalPaymentAmount', value: '' },
        { name: 'mastercardMinPayment', value: '' },
        { name: 'mastercardMaxPayment', value: '' },
        { name: 'isAcceptMasterCardVariableFee', value: null }
      ]

      columns.forEach(column => {
        tmpCardInfo = {
          ...tmpCardInfo,
          [column.name]: column.value
        }
      })
    }

    setSuppliercardInfo(tmpCardInfo)
    onInfoChange(true)
  }

  const handleAcceptancePerCardChange = (checked) => {
    setShowAcceptancePerCard(checked)
    checked ?
      setAccPerCardText('Generic Fee Structure')
      :
      setAccPerCardText('Acceptance Per Card')

    setShowAmexMinFee(suppliercardInfo?.amexMinPaymentFeeValue ? true : false)
    setShowAmexMaxFee(suppliercardInfo?.amexMaxPaymentFeeValue ? true : false)
    setShowAmexIncrementalFee((suppliercardInfo?.amexIncrementalFeeValue || suppliercardInfo?.amexIncrementalPaymentAmount) ? true : false)
    setShowVisaMinFee(suppliercardInfo?.visaMinPaymentFeeValue ? true : false)
    setShowVisaMaxFee(suppliercardInfo?.visaMaxPaymentFeeValue ? true : false)
    setShowVisaIncrementalFee((suppliercardInfo?.visaIncrementalFeeValue || suppliercardInfo?.visaIncrementalPaymentAmount) ? true : false)
    setShowMasterMinFee(suppliercardInfo?.mastercardMinPaymentFeeValue ? true : false)
    setShowMasterMaxFee(suppliercardInfo?.mastercardMaxPaymentFeeValue ? true : false)
    setShowMasterIncrementalFee((suppliercardInfo?.mastercardIncrementalFeeValue || suppliercardInfo?.mastercardIncrementalPaymentAmount) ? true : false)
    setShowAmexAnotherProcessingFee(suppliercardInfo?.amexSecondProcessingFeeValue ? true : false)
    setShowVisaAnotherProcessingFee(suppliercardInfo?.visaSecondProcessingFeeValue ? true : false)
    setShowMasterAnotherProcessingFee(suppliercardInfo?.mastercardSecondProcessingFeeValue ? true : false)
    setSuppliercardInfo({
      ...suppliercardInfo,
      isAcceptAcceptancePerCard: checked
    })
    onInfoChange(true)
  }

  const handleSecondProcessingFeeValueChange = () => {
    setShowAnotherProcessingFee(false);
    handleChangeGenericFeeInfo('processingSecondFeeValue', '', ['amexSecondProcessingFeeValue', 'visaSecondProcessingFeeValue', 'mastercardSecondProcessingFeeValue'], '', [], genericFeeValues?.processingSecondFeeType === '$' ? 'currency' : 'percent')
  }

  const handleCardsSecondProcessingFeeValueChange = (cardType, cardFeeTypeColumn, cardFeeValueColumn) => {
    cardType === 'amex' ? setShowAmexAnotherProcessingFee(false) : cardType === 'visa' ? setShowVisaAnotherProcessingFee(false) : setShowMasterAnotherProcessingFee(false);
    handleChangeCardInfo(cardFeeValueColumn, '', suppliercardInfo?.[cardFeeTypeColumn] === '$' ? 'currency' : 'percent');
  }

  const handleProductSpecificOptionsChange = (colName, optionValue) => {
    setSuppliercardInfo({
      ...suppliercardInfo,
      [colName]: optionValue
    })
    onInfoChange(true)
  }

  const getRemittanceRequirements = (columnName) => {
    return (
      <Select
        className="col-4 remit-requirements-selector ms-0 ms-sm-auto h4 mb-0 no-zIndex"
        placeholder="Remittance Requirements"
        classNamePrefix='react-select-selector'
        isMulti
        isClearable={false}
        options={
          remit_requirements_options.map((option) => ({
            label: option,
            value: option.toLowerCase().replaceAll(' ', '-')
          }))
        }
        value={suppliercardInfo?.[columnName]}
        onChange={(options) => { handleProductSpecificOptionsChange(columnName, options) }}
      />
    )
  }

  const handleCardConditionsChange = (colName, value) => {
    const amexColumns = [
      { name: 'amexProcessingFeeType', value: '$' },
      { name: 'amexProcessingFeeValue', value: '' },
      { name: 'amexSecondProcessingFeeType', value: '$' },
      { name: 'amexSecondProcessingFeeValue', value: '' },
      { name: 'amexMinPaymentFeeType', value: '$' },
      { name: 'amexMinPaymentFeeValue', value: '' },
      { name: 'amexMaxPaymentFeeType', value: '$' },
      { name: 'amexMaxPaymentFeeValue', value: '' },
      { name: 'amexIncrementalFeeType', value: '$' },
      { name: 'amexIncrementalFeeValue', value: '' },
      { name: 'americanExpressMinPaymnet', value: '' },
      { name: 'americanExpressMaxPayment', value: '' },
      { name: 'amexIncrementalPaymentAmount', value: '' },
      { name: 'isAcceptAmexVariableFee', value: null }
    ]

    const visaColumns = [
      { name: 'visaProcessingFeeType', value: '$' },
      { name: 'visaProcessingFeeValue', value: '' },
      { name: 'visaSecondProcessingFeeType', value: '$' },
      { name: 'visaSecondProcessingFeeValue', value: '' },
      { name: 'visaMinPaymentFeeType', value: '$' },
      { name: 'visaMinPaymentFeeValue', value: '' },
      { name: 'visaMaxPaymentFeeType', value: '$' },
      { name: 'visaMaxPaymentFeeValue', value: '' },
      { name: 'visaIncrementalFeeType', value: '$' },
      { name: 'visaIncrementalFeeValue', value: '' },
      { name: 'visaMinPayment', value: '' },
      { name: 'visaMaxPayment', value: '' },
      { name: 'visaIncrementalPaymentAmount', value: '' },
      { name: 'isAcceptVisaVariableFee', value: null }
    ]

    const masterColumns = [
      { name: 'mastercardProcessingFeeType', value: '$' },
      { name: 'mastercardProcessingFeeValue', value: '' },
      { name: 'mastercardSecondProcessingFeeType', value: '$' },
      { name: 'mastercardSecondProcessingFeeValue', value: '' },
      { name: 'mastercardMinPaymentFeeType', value: '$' },
      { name: 'mastercardMinPaymentFeeValue', value: '' },
      { name: 'mastercardMaxPaymentFeeType', value: '$' },
      { name: 'mastercardMaxPaymentFeeValue', value: '' },
      { name: 'mastercardIncrementalFeeType', value: '$' },
      { name: 'mastercardIncrementalFeeValue', value: '' },
      { name: 'mastercardMinPayment', value: '' },
      { name: 'mastercardMaxPayment', value: '' },
      { name: 'mastercardIncrementalPaymentAmount', value: '' },
      { name: 'isAcceptMasterCardVariableFee', value: null }
    ]

    if (value) {
      setSuppliercardInfo({
        ...suppliercardInfo,
        [colName]: value
      })
    } else {
      var columns = amexColumns
      if (colName === 'isAcceptAmexCardConditions') {
        setShowAmexIncrementalFee(false)
      }

      if (colName === 'isAcceptVisaCardConditions') {
        columns = visaColumns
        setShowVisaIncrementalFee(false)
      }
      if (colName === 'isAcceptMastercardCardConditions') {
        columns = masterColumns
        setShowMasterIncrementalFee(false)
      }
      const tmpCardInfo = { ...suppliercardInfo }

      columns.forEach(column => {
        tmpCardInfo[column.name] = column.value
      })

      tmpCardInfo[colName] = value
      setSuppliercardInfo(tmpCardInfo)
    }
    onInfoChange(true)
  }

  const onContactMouseHover = (event) => {
    const parentWithClass = event.target.closest('.react-tel-input')
    if (event.target?.dataset?.contactId) {
      const contact = allContacts?.find(data => data?.id === parseInt(event.target?.dataset?.contactId))
      setCurrentContact(contact ? contact : {})
    } else {
      setCurrentContact({})
    }

    if (parentWithClass && parentWithClass?.nextSibling && parentWithClass?.nextSibling.classList?.value?.includes('contact-view')) {
      parentWithClass.nextSibling.style.display = 'block'
    } else if (event.target && event.target?.nextSibling && event.target?.nextSibling?.classList?.value?.includes('contact-view')) {
      event.target.nextSibling.style.display = 'block'
    }
  }

  const onContactMouseHoverOut = (event) => {
    const parentWithClass = event.target.closest('.react-tel-input')
    if (parentWithClass && parentWithClass?.nextSibling && parentWithClass?.nextSibling.classList?.value?.includes('contact-view')) {
      parentWithClass.nextSibling.style.display = 'none'
    } else if (event.target && event.target?.nextSibling && event.target?.nextSibling.classList?.value?.includes('contact-view')) {
      event.target.nextSibling.style.display = 'none'
    }
    setCurrentContact({})
  }

  const onPhoneEmailClick = (type1, type2, type3) => {
    setShowAllContacts({ ...showAllContacts, [type1]: !showAllContacts?.[type1], [type2]: false, [type3]: false })
    if (type1 === 'email' && !suppliercardEmailsInfo?.[0]?.emailContactId && suppliercardEmailsInfo?.[0]?.email?.trim() && suppliercardEmailsInfo?.[0]?.email?.trim()?.length >= 4) {
      onGetExistingContacts(suppliercardEmailsInfo?.[0]?.email?.trim(), 'email')
    } else if (type1 === 'phone' && !suppliercardInfo?.phoneContactId && suppliercardInfo?.cardPaymentByPhoneValue?.trim() && suppliercardInfo?.cardPaymentByPhoneValue?.trim()?.length >= 4) {
      onGetExistingContacts(suppliercardInfo?.cardPaymentByPhoneValue?.trim(), 'phone')
    } else if (type1 === 'ivrPhone' && !suppliercardInfo?.ivrPhoneContactId && suppliercardInfo?.cardPaymentIVRPhone?.trim() && suppliercardInfo?.cardPaymentIVRPhone?.trim()?.length >= 4) {
      onGetExistingContacts(suppliercardInfo?.cardPaymentIVRPhone?.trim(), 'phone')
    } else {
      setExistedContacts(allContacts)
    }
  }

  const onPhoneEmailFocusOutClick = () => {
    setShowAllContacts({ ...showAllContacts, email: false, phone: false, ivrPhone: false })
    setExistedContacts(allContacts)
  }

  useEffect(() => {
    if (showAllContacts?.phone && suppliercardInfo?.cardPaymentByPhoneValue?.trim() && suppliercardInfo?.cardPaymentByPhoneValue?.trim()?.length >= 4) {
      setIsLoadingExistingContacts(true)
      const delayDebounceFn = setTimeout(async () => {
        onGetExistingContacts(suppliercardInfo?.cardPaymentByPhoneValue?.trim(), 'phone')
      }, 1000)
      return () => clearTimeout(delayDebounceFn)
    } else {
      setIsLoadingExistingContacts(false)
    }
  }, [suppliercardInfo?.cardPaymentByPhoneValue])

  useEffect(() => {
    if (showAllContacts?.ivrPhone && suppliercardInfo?.cardPaymentIVRPhone?.trim() && suppliercardInfo?.cardPaymentIVRPhone?.trim()?.length >= 4) {
      setIsLoadingExistingContacts(true)
      const delayDebounceFn = setTimeout(async () => {
        onGetExistingContacts(suppliercardInfo?.cardPaymentIVRPhone?.trim(), 'phone')
      }, 1000)
      return () => clearTimeout(delayDebounceFn)
    } else {
      setIsLoadingExistingContacts(false)
    }
  }, [suppliercardInfo?.cardPaymentIVRPhone])

  useEffect(() => {
    if (showAllContacts?.email && suppliercardEmailsInfo && suppliercardEmailsInfo?.[0]?.email?.trim()?.length >= 4) {
      setIsLoadingExistingContacts(true)
      const delayDebounceFn = setTimeout(async () => {
        onGetExistingContacts(suppliercardEmailsInfo?.[0]?.email?.trim(), 'email')
      }, 1000)
      return () => clearTimeout(delayDebounceFn)
    } else {
      setIsLoadingExistingContacts(false)
    }
  }, [suppliercardEmailsInfo?.[0]?.email])

  const onGetExistingContacts = (searchValue, type = '') => {
    try {
      setIsLoadingExistingContacts(true)
      dispatch(getExistingContacts({ searchValue, type })).then((res) => {
        if (res?.contacts && res?.contacts?.length > 0) {
          if (masterSupplierDetails?.baseInfo?.id) {
            res?.contacts.sort((a, b) => {
              const aContains = a?.supplierIds.includes(masterSupplierDetails?.baseInfo?.id) ? 1 : 0;
              const bContains = b?.supplierIds.includes(masterSupplierDetails?.baseInfo?.id) ? 1 : 0;
              return bContains - aContains;
            })
          }
          setExistedContacts(res?.contacts)
        } else {
          setExistedContacts([])
        }
        setIsLoadingExistingContacts(false)
      }).catch(() => {
        setExistedContacts([])
        setIsLoadingExistingContacts(false)
      })
    } catch (err) {
      setExistedContacts([])
      setIsLoadingExistingContacts(false)
    }
  }

  const handleContactClick = async (rowData) => {
    const tmpData = { ...suppliercardInfo }
    if (showAllContacts?.phone) {
      if (!rowData?.phone) {
        toast.show({
          title: 'Warning',
          description: 'No phone number is assigned to this contact!'
        })
        return
      }
      tmpData.cardPaymentByPhoneValue = rowData?.phone || ''
      tmpData.phoneContactId = rowData?.id || null
      await handlePhoneNumberFocusOut(null, null, tmpData.cardPaymentByPhoneValue, 'cardPaymentByPhoneValue')
      setShowAllContacts({ ...showAllContacts, phone: false })
    }
    if (showAllContacts?.ivrPhone) {
      if (!rowData?.phone) {
        toast.show({
          title: 'Warning',
          description: 'No phone number is assigned to this contact!'
        })
        return
      }
      tmpData.cardPaymentIVRPhone = rowData?.phone || ''
      tmpData.ivrPhoneContactId = rowData?.id || null
      await handlePhoneNumberFocusOut(null, null, tmpData.cardPaymentIVRPhone, 'cardPaymentIVRPhone')
      setShowAllContacts({ ...showAllContacts, ivrPhone: false })
    }
    if (showAllContacts?.email) {
      if (!rowData?.email) {
        toast.show({
          title: 'Warning',
          description: 'No email is assigned to this contact!'
        })
        return
      }
      await handleEmailFocusOut(rowData?.email || '')
      setSuppliercardEmailsInfo({
        ...suppliercardEmailsInfo, [0]: {
          email: rowData?.email || '',
          emailContactId: rowData?.id || null
        }
      })
      setShowAllContacts({ ...showAllContacts, email: false })
    }
    setSuppliercardInfo(tmpData)
    if (rowData) {
      const tmpContacts = allContacts && allContacts?.length > 0 ? [...allContacts] : []
      const index = tmpContacts?.findIndex(data => data?.id === rowData?.id)
      if (index === -1) {
        tmpContacts.push(rowData)
      }
      setAllContacts(tmpContacts)
    }
    onPhoneEmailFocusOutClick()
  }

  const handleOnCreateContact = () => {
    let value = ''
    let colName = ''
    let colToUpdate = ''
    if (showAllContacts?.phone) {
      colName = 'phone'
      colToUpdate = 'cardPaymentByPhoneValue'
      value = suppliercardInfo?.cardPaymentByPhoneValue ? (!/^\s*(?:\+?(\d{1,3})\s)/.test(suppliercardInfo?.cardPaymentByPhoneValue) ? `1 ${suppliercardInfo?.cardPaymentByPhoneValue}` : suppliercardInfo?.cardPaymentByPhoneValue) : ''
    } else if (showAllContacts?.ivrPhone) {
      colName = 'phone'
      colToUpdate = 'cardPaymentIVRPhone'
      value = suppliercardInfo?.cardPaymentIVRPhone ? (!/^\s*(?:\+?(\d{1,3})\s)/.test(suppliercardInfo?.cardPaymentIVRPhone) ? `1 ${suppliercardInfo?.cardPaymentIVRPhone}` : suppliercardInfo?.cardPaymentIVRPhone) : ''
    } else {
      colName = 'email'
      colToUpdate = 'email'
      value = suppliercardEmailsInfo?.[0]?.email || ''
    }
    onCreateContact({
      tab: 'card',
      colName: colName,
      colToUpdate,
      value: value,
      ref: cardInfoSaveRef
    })
    onPhoneEmailFocusOutClick()
  }

  const onCreateContactForEmailPhone = (colName = null, contactId = null, value = '') => {
    if (colName && contactId) {
      if (colName === 'cardPaymentByPhoneValue') {
        setSuppliercardInfo({ ...suppliercardInfo, phoneContactId: contactId, cardPaymentByPhoneValue: value })
        // supplierInfo.emailContactId = contactId
        setIsPhoneValid(true)
      }
      if (colName === 'cardPaymentIVRPhone') {
        setSuppliercardInfo({ ...suppliercardInfo, ivrPhoneContactId: contactId, cardPaymentIVRPhone: value })
        // supplierInfo.phoneContactId = contactId
        setIsIVRPhoneValid(true)
      }
      if (colName === 'email') {
        setSuppliercardEmailsInfo({
          ...suppliercardEmailsInfo, [0]: {
            email: value || '',
            emailContactId: contactId || null
          }
        })
        setIsEmailValid(true)
      }
    }
  }

  const onGetContactsData = () => {
    if (showAllContacts?.phone) {
      onGetExistingContacts(suppliercardInfo?.cardPaymentByPhoneValue?.trim(), 'phone')
    } else if (showAllContacts?.ivrPhone) {
      onGetExistingContacts(suppliercardInfo?.cardPaymentIVRPhone?.trim(), 'phone')
    } else if (showAllContacts?.email) {
      onGetExistingContacts(suppliercardEmailsInfo?.[0]?.email?.trim(), 'email')
    }
  }

  const handleRemoveContact = (colName) => {
    if (colName === 'email') {
      setSuppliercardEmailsInfo({})
      setIsEmailValid(true)
    } else if (colName === 'phone') {
      setSuppliercardInfo({ ...suppliercardInfo, phoneContactId: null, cardPaymentByPhoneValue: '' })
      setIsPhoneValid(true)
    } else if (colName === 'ivrPhone') {
      setSuppliercardInfo({ ...suppliercardInfo, ivrPhoneContactId: null, cardPaymentIVRPhone: '' })
      setIsIVRPhoneValid(true)
    }
  }

  return (
    <div className="card supply-card-acceptance mt-0 pt-0">
      {(isLoadingMasterDetail || isLoading) && <LoaderComponent />}
      <div className="card-header flex-column flex-sm-row align-items-start align-items-sm-center pt-2 pb-2 h-auto">
        <h3 className='fw-bold mb-0'>Card Acceptance</h3>
        <div className="tool d-flex gap-3">
          <button type="button" className="card-edit-button me-0 ps-3 pe-3 ps-sm-4 pe-sm-4 width-100" onClick={handleClickCancel}>Cancel</button>
          {(isValidatingPhone || isValidatingEmail || isValidatingIVRPhone) ? (
            <button type="button" className="card-edit-button me-0 ps-3 pe-3 ps-sm-4 pe-sm-4">Validating...</button>
          ) : (
            <button type="button" className="card-edit-button ps-3 pe-3 ps-sm-4 pe-sm-4 width-100" onClick={handleSave} ref={cardInfoSaveRef}>Save</button>
          )}
        </div>
      </div>
      <div className="card-content">
        {!showAcceptancePerCard ?
          <>
            <div className='item'>
              <h4 className='fw-bold toggle-item-text mb-0'>Accepts Credit Cards:
                <img className='item-image ms-0 ms-sm-3' src={AmexImg} />
                <img className='item-image ms-0 ms-sm-3' src={VisaImg} />
                <img className='item-image ms-0 ms-sm-3' src={MasterCardImg} />
                <input type="checkbox" className="btn-check" id="btn-check" autoComplete="off" checked={showAcceptancePerCard} onChange={(event) => { handleAcceptancePerCardChange(event.target.checked) }} />
                <label className="btn btn-success p-3 ms-3" htmlFor="btn-check">{accPerCardText}</label>
              </h4>
              <ThreeStateToggleButton onChange={(checked) => { handleChangeGenericFeeInfo('showCreditCards', checked, ['isAcceptAmericanExpress', 'isAcceptMasterCard', 'isAcceptVisa']); setShowAmex(checked); setShowMaster(checked); setShowVisa(checked); }} checked={genericFeeValues?.showCreditCards} />
            </div>
            {
              genericFeeValues?.showCreditCards && !suppliercardInfo?.advancedAcceptanceEnabled && (
                <div className="item processing-fee">
                  <h4 className='fw-bold mb-0'>Credit Card Conditions:</h4>
                  {genericFeeValues?.showCreditCards ? (
                    <div className='flex processing-fee-parent align-items-center'>
                      <h4 className={`fw-bold mb-0${genericFeeValues?.showCardConditions ? '' : ' d-none'}`}>Fee</h4>
                      <div className='d-flex align-items-center'>
                        <h4 className={`fw-bold mb-0${genericFeeValues?.showCardConditions ? '' : ' d-none'}`}>Amount</h4>
                        <ThreeStateToggleButton customClass='ms-auto' onChange={(checked) => { handleChangeGenericFeeInfo('showCardConditions', checked, ['isAcceptAmexCardConditions', 'isAcceptVisaCardConditions', 'isAcceptMastercardCardConditions']) }} checked={genericFeeValues?.showCardConditions} />
                      </div>
                    </div>
                  ) :
                    <div></div>}
                </div>
              )
            }
            {
              genericFeeValues?.showCreditCards && !suppliercardInfo?.advancedAcceptanceEnabled && (
                genericFeeValues?.showCardConditions && (
                  <div className="fee-item">
                    <div className="row g-0 flex-column flex-md-row">
                      <h4 className="name mb-0">Credit Card Processing Fee</h4>
                      <div className='processing-fee-parent flex'>
                        <div className='flex processing-fee-dropdown-parent align-items-start align-center gap-2 flex-column'>
                          <div className='d-flex'>
                            <div className='flex processing-fee-dropdown-child flex-grow-1'>
                              <Select //flex-sm-grow-0
                                menuMaxHeight={48}
                                className="processing-fee-dropdown h4 mb-0 no-zIndex"
                                options={
                                  [
                                    {
                                      label: '$',
                                      value: '$',
                                    },
                                    {
                                      label: '%',
                                      value: '%',
                                    },
                                  ]
                                }
                                value={{
                                  label: genericFeeValues?.processingFeeType || '$',
                                  value: genericFeeValues?.processingFeeType || '$',
                                }}
                                onChange={(item) => { handleChangeGenericFeeInfo('processingFeeType', item?.value, ['amexProcessingFeeType', 'visaProcessingFeeType', 'mastercardProcessingFeeType'], 'processingFeeValue', ['amexProcessingFeeValue', 'visaProcessingFeeValue', 'mastercardProcessingFeeValue']) }}
                              />
                              <input
                                className='search-input'
                                value={genericFeeValues?.processingFeeValue || ''}
                                onChange={(e) => { handleChangeGenericFeeInfo('processingFeeValue', e.target.value, ['amexProcessingFeeValue', 'visaProcessingFeeValue', 'mastercardProcessingFeeValue'], '', [], genericFeeValues?.processingFeeType === '$' ? 'currency' : 'percent') }}
                                placeholder={genericFeeValues?.processingFeeType === '$' ? '1,234.00' : '12.50'}
                              />
                            </div>
                            <button className='ms-2 show-option-btn' disabled={(!genericFeeValues?.processingFeeValue || showAnotherProcessingFee) ? true : false} onClick={() => setShowAnotherProcessingFee(true)}> + </button>
                          </div>

                          {showAnotherProcessingFee && (
                            <div className='d-flex'>
                              <div className='flex processing-fee-dropdown-parent align-center'>
                                <div className='flex processing-fee-dropdown-child flex-grow-1'>
                                  <Select // flex-sm-grow-0
                                    menuMaxHeight={48}
                                    className="processing-fee-dropdown h4 mb-0 no-zIndex"
                                    options={
                                      [
                                        {
                                          label: '$',
                                          value: '$',
                                        },
                                        {
                                          label: '%',
                                          value: '%',
                                        },
                                      ]
                                    }
                                    value={{
                                      label: genericFeeValues?.processingSecondFeeType || '$',
                                      value: genericFeeValues?.processingSecondFeeType || '$',
                                    }}
                                    onChange={(item) => { handleChangeGenericFeeInfo('processingSecondFeeType', item?.value, ['amexSecondProcessingFeeType', 'visaSecondProcessingFeeType', 'mastercardSecondProcessingFeeType'], 'processingSecondFeeValue', ['amexSecondProcessingFeeValue', 'visaSecondProcessingFeeValue', 'mastercardSecondProcessingFeeValue']) }}
                                  />
                                  <input
                                    className='search-input'
                                    value={genericFeeValues?.processingSecondFeeValue || ''}
                                    onChange={(e) => { handleChangeGenericFeeInfo('processingSecondFeeValue', e.target.value, ['amexSecondProcessingFeeValue', 'visaSecondProcessingFeeValue', 'mastercardSecondProcessingFeeValue'], '', [], genericFeeValues?.processingSecondFeeType === '$' ? 'currency' : 'percent') }}
                                    placeholder={genericFeeValues?.processingSecondFeeType === '$' ? '1,234.00' : '12.50'}
                                  />
                                </div>
                                <button className='ms-2 hide-option-btn' onClick={() => handleSecondProcessingFeeValueChange()}> - </button>
                              </div>
                            </div>
                          )}

                        </div>
                        <div className='d-none d-sm-block'></div>
                      </div>
                    </div>
                    <div className="row g-0 flex-column flex-md-row">
                      <h4 className="name mb-0">Credit Card Minimum Payment:</h4>
                      <div className='processing-fee-parent gap-3 gap-sm-0 d-flex flex-column flex-sm-row'>
                        {genericFeeValues?.showMinFee ? (
                          <div className='flex processing-fee-dropdown-parent align-center'>
                            <div className='flex processing-fee-dropdown-child'>
                              <Select
                                className="processing-fee-dropdown h4 mb-0 no-zIndex"
                                options={
                                  [
                                    {
                                      label: '$',
                                      value: '$',
                                    },
                                    {
                                      label: '%',
                                      value: '%',
                                    },
                                  ]
                                }
                                value={{
                                  label: genericFeeValues?.minFeeType || '$',
                                  value: genericFeeValues?.minFeeType || '$',
                                }}
                                onChange={(item) => { handleChangeGenericFeeInfo('minFeeType', item?.value, ['amexMinPaymentFeeType', 'visaMinPaymentFeeType', 'mastercardMinPaymentFeeType'], 'minFeeValue', ['amexMinPaymentFeeValue', 'visaMinPaymentFeeValue', 'mastercardMinPaymentFeeValue']) }}
                              />
                              <input
                                className='search-input'
                                value={genericFeeValues?.minFeeValue || ''}
                                onChange={(e) => { handleChangeGenericFeeInfo('minFeeValue', e.target.value, ['amexMinPaymentFeeValue', 'visaMinPaymentFeeValue', 'mastercardMinPaymentFeeValue'], '', [], genericFeeValues?.minFeeType === '$' ? 'currency' : 'percent') }}
                                placeholder={genericFeeValues?.minFeeType === '$' ? '1,234.00' : '12.50'}
                              />
                            </div>
                            <h4 className='flex-grow-1 text-center mb-0 text-black'>Fee if under</h4>
                          </div>
                        )
                          : <div></div>}
                        <div className='flex payment-parent'>
                          <div className="search-input-parent currency">
                            {genericFeeValues?.minPayment ?
                              <span>$</span>
                              :
                              ''
                            }
                            <input
                              type="text"
                              className={`search-input ${genericFeeValues?.minPayment ? 'has-value' : ''}`}
                              value={genericFeeValues?.minPayment || ''}
                              onChange={(e) => { handleChangeGenericFeeInfo('minPayment', e.target.value, ['americanExpressMinPaymnet', 'visaMinPayment', 'mastercardMinPayment'], '', [], 'currency') }}
                              placeholder='$ 1,234.00'
                            />
                          </div>
                          {genericFeeValues?.showMinFee ?
                            <button className='hide-option' onClick={() => handleChangeGenericFeeInfo('showMinFee', false, [], '', [], 'showHideFee')}> - </button>
                            :
                            <button className='show-option' onClick={() => handleChangeGenericFeeInfo('showMinFee', true, [], '', [], 'showHideFee')}> + </button>
                          }
                        </div>
                      </div>
                    </div>
                    <div className="row g-0 flex-column flex-md-row">
                      <h4 className="name mb-0">Credit Card Maximum Payment:</h4>
                      <div className='processing-fee-parent gap-3 gap-sm-0 d-flex flex-column flex-sm-row'>
                        {genericFeeValues?.showMaxFee ? (
                          <div className='flex processing-fee-dropdown-parent align-center'>
                            <div className='flex processing-fee-dropdown-child'>
                              <Select
                                className="processing-fee-dropdown h4 mb-0 no-zIndex"
                                options={
                                  [
                                    {
                                      label: '$',
                                      value: '$',
                                    },
                                    {
                                      label: '%',
                                      value: '%',
                                    },
                                  ]
                                }
                                value={{
                                  label: genericFeeValues?.maxFeeType || '$',
                                  value: genericFeeValues?.maxFeeType || '$',
                                }}
                                onChange={(item) => { handleChangeGenericFeeInfo('maxFeeType', item?.value, ['amexMaxPaymentFeeType', 'visaMaxPaymentFeeType', 'mastercardMaxPaymentFeeType'], 'maxFeeValue', ['amexMaxPaymentFeeValue', 'visaMaxPaymentFeeValue', 'mastercardMaxPaymentFeeValue']) }}
                              />
                              <input
                                className='search-input'
                                value={genericFeeValues?.maxFeeValue || ''}
                                onChange={(e) => { handleChangeGenericFeeInfo('maxFeeValue', e.target.value, ['amexMaxPaymentFeeValue', 'visaMaxPaymentFeeValue', 'mastercardMaxPaymentFeeValue'], '', [], genericFeeValues?.maxFeeType === '$' ? 'currency' : 'percent') }}
                                placeholder={genericFeeValues?.maxFeeType === '$' ? '1,234.00' : '12.50'}
                              />
                            </div>
                            <h4 className='flex-grow-1 text-center mb-0 text-black'>Fee if over</h4>
                          </div>
                        )
                          : <div></div>}
                        <div className='flex payment-parent'>
                          <div className="search-input-parent currency">
                            {genericFeeValues?.maxPayment ?
                              <span>$</span>
                              :
                              ''
                            }
                            <input
                              type="text"
                              className={`search-input ${genericFeeValues?.maxPayment ? 'has-value' : ''}`}
                              value={genericFeeValues?.maxPayment || ''}
                              onChange={(e) => { handleChangeGenericFeeInfo('maxPayment', e.target.value, ['americanExpressMaxPayment', 'visaMaxPayment', 'mastercardMaxPayment'], '', [], 'currency') }}
                              placeholder='$ 1,234.00'
                            />
                          </div>
                          {genericFeeValues?.showMaxFee ?
                            <button className='hide-option' onClick={() => handleChangeGenericFeeInfo('showMaxFee', false, [], '', [], 'showHideFee')}> - </button>
                            :
                            <button className='show-option' onClick={() => handleChangeGenericFeeInfo('showMaxFee', true, [], '', [], 'showHideFee')}> + </button>
                          }
                        </div>
                      </div>
                    </div>
                    <div className="row g-0 flex-column flex-md-row">
                      <h4 className="name mb-0">Incremental Fee:</h4>
                      <div className='processing-fee-parent gap-3 gap-sm-0 d-flex flex-column flex-sm-row'>
                        {genericFeeValues?.showIncrementalFee ? (
                          <div className='flex processing-fee-dropdown-parent align-center'>
                            <div className='flex processing-fee-dropdown-child'>
                              <Select
                                className="processing-fee-dropdown h4 mb-0 no-zIndex"
                                options={
                                  [
                                    {
                                      label: '$',
                                      value: '$',
                                    },
                                    {
                                      label: '%',
                                      value: '%',
                                    },
                                  ]
                                }
                                value={{
                                  label: genericFeeValues?.incrementalFeeType || '$',
                                  value: genericFeeValues?.incrementalFeeType || '$',
                                }}
                                onChange={(item) => { handleChangeGenericFeeInfo('incrementalFeeType', item?.value, ['amexIncrementalFeeType', 'visaIncrementalFeeType', 'mastercardIncrementalFeeType'], 'incrementalFeeValue', ['amexIncrementalFeeValue', 'visaIncrementalFeeValue', 'mastercardIncrementalFeeValue']) }}
                              />
                              <input
                                className='search-input'
                                value={genericFeeValues?.incrementalFeeValue || ''}
                                onChange={(e) => { handleChangeGenericFeeInfo('incrementalFeeValue', e.target.value, ['amexIncrementalFeeValue', 'visaIncrementalFeeValue', 'mastercardIncrementalFeeValue'], '', [], genericFeeValues?.incrementalFeeType === '$' ? 'currency' : 'percent') }}
                                placeholder={genericFeeValues?.incrementalFeeType === '$' ? '1,234.00' : '12.50'}
                              />
                            </div>
                            <h4 className='flex-grow-1 text-center mb-0 text-black'>Fee for every</h4>
                          </div>
                        )
                          : <div></div>}
                        <div className='flex payment-parent'>
                          {genericFeeValues?.showIncrementalFee ? (
                            <div className="search-input-parent currency">
                              {genericFeeValues?.incrementalPayment ?
                                <span>$</span>
                                :
                                ''
                              }
                              <input
                                type="text"
                                className={`search-input ${genericFeeValues?.incrementalPayment ? 'has-value' : ''}`}
                                value={genericFeeValues?.incrementalPayment || ''}
                                onChange={(e) => { handleChangeGenericFeeInfo('incrementalPayment', e.target.value, ['amexIncrementalPaymentAmount', 'visaIncrementalPaymentAmount', 'mastercardIncrementalPaymentAmount'], '', [], 'currency') }}
                                placeholder='$ 1,234.00'
                              />
                            </div>
                          )
                            : <div></div>}
                          {genericFeeValues?.showIncrementalFee ?
                            <button className='hide-option' onClick={() => handleChangeGenericFeeInfo('showIncrementalFee', false, [], '', [], 'showHideFee')}> - </button>
                            :
                            <button className='show-option' onClick={() => handleChangeGenericFeeInfo('showIncrementalFee', true, [], '', [], 'showHideFee')}> + </button>
                          }
                        </div>
                      </div>
                    </div>
                    <div className="item">
                      <h4 className="name toggle-item-text mb-0">Variable Fee:</h4>
                      <ThreeStateToggleButton onChange={(checked) => { handleChangeGenericFeeInfo('showVariableFee', checked, ['isAcceptAmexVariableFee', 'isAcceptVisaVariableFee', 'isAcceptMasterCardVariableFee']); }} checked={genericFeeValues?.showVariableFee} />
                    </div>
                  </div>
                )
              )
            }
          </>
          :
          <>
            <div className="item">
              <input type="checkbox" className="btn-check" id="btn-check" autoComplete="off" checked={showAcceptancePerCard} onChange={(event) => { handleAcceptancePerCardChange(event.target.checked) }} />
              <label className="btn btn-success p-3" htmlFor="btn-check">{accPerCardText}</label>
            </div>
            <div className="item">
              <h4 className='fw-bold toggle-item-text mb-0'>Accepts Amex: <img className='item-image ms-0 ms-sm-3' src={AmexImg} /> </h4>
              <ThreeStateToggleButton onChange={handleToggleAmex} checked={showAmex} />
            </div>

            {
              showAmex && !suppliercardInfo?.advancedAcceptanceEnabled && (
                <div className="item processing-fee">
                  <h4 className='fw-bold mb-0'>Amex Conditions:</h4>
                  {showAmex ? (
                    <div className='flex processing-fee-parent align-items-center'>
                      <h4 className={`fw-bold mb-0${suppliercardInfo?.isAcceptAmexCardConditions ? '' : ' d-none'}`}>Fee</h4>
                      <div className='d-flex align-items-center'>
                        <h4 className={`fw-bold mb-0${suppliercardInfo?.isAcceptAmexCardConditions ? '' : ' d-none'}`}>Amount</h4>
                        <ThreeStateToggleButton customClass='ms-auto' onChange={(checked) => { handleCardConditionsChange('isAcceptAmexCardConditions', checked) }} checked={suppliercardInfo?.isAcceptAmexCardConditions} />
                      </div>
                    </div>
                  ) :
                    <div></div>}
                </div>
              )
            }
            {
              showAmex && !suppliercardInfo?.advancedAcceptanceEnabled && suppliercardInfo?.isAcceptAmexCardConditions && (
                <div className="fee-item">
                  <div className="row g-0 flex-column flex-md-row">
                    <h4 className="name mb-0">Amex Processing Fee</h4>
                    <div className='processing-fee-parent flex'>
                      <div className='flex processing-fee-dropdown-parent align-items-start align-center gap-2 flex-column'>
                        <div className='d-flex'>
                          <div className='flex processing-fee-dropdown-child flex-grow-1'>
                            <Select
                              menuMaxHeight={48}
                              className="processing-fee-dropdown h4 mb-0 no-zIndex"
                              options={
                                [
                                  {
                                    label: '$',
                                    value: '$',
                                  },
                                  {
                                    label: '%',
                                    value: '%',
                                  },
                                ]
                              }
                              value={{
                                label: suppliercardInfo?.amexProcessingFeeType || '$',
                                value: suppliercardInfo?.amexProcessingFeeType || '$',
                              }}
                              onChange={(item) => { handleUpdateCardFeeInfo('amexProcessingFeeType', item, 'feeValue', 'amexProcessingFeeValue') }}
                            />
                            <input
                              className='search-input'
                              value={suppliercardInfo?.amexProcessingFeeValue || ''}
                              onChange={(e) => { handleChangeCardInfo('amexProcessingFeeValue', e.target.value, (!suppliercardInfo?.amexProcessingFeeType || suppliercardInfo?.amexProcessingFeeType === '$') ? 'currency' : 'percent') }}
                              placeholder={(!suppliercardInfo?.amexProcessingFeeType || suppliercardInfo?.amexProcessingFeeType === '$') ? '1,234.00' : '12.50'}
                            />
                          </div>
                          <button className='ms-2 show-option-btn' disabled={(!suppliercardInfo?.amexProcessingFeeValue || showAmexAnotherProcessingFee) ? true : false} onClick={() => setShowAmexAnotherProcessingFee(true)}> + </button>
                        </div>

                        {showAmexAnotherProcessingFee && (
                          <div className='d-flex'>
                            <div className='flex processing-fee-dropdown-parent align-center'>
                              <div className='flex processing-fee-dropdown-child flex-grow-1'>
                                <Select // flex-sm-grow-0
                                  menuMaxHeight={48}
                                  className="processing-fee-dropdown h4 mb-0 no-zIndex"
                                  options={
                                    [
                                      {
                                        label: '$',
                                        value: '$',
                                      },
                                      {
                                        label: '%',
                                        value: '%',
                                      },
                                    ]
                                  }
                                  value={{
                                    label: suppliercardInfo?.amexSecondProcessingFeeType || '$',
                                    value: suppliercardInfo?.amexSecondProcessingFeeType || '$',
                                  }}
                                  onChange={(item) => { handleUpdateCardFeeInfo('amexSecondProcessingFeeType', item, 'feeValue', 'amexSecondProcessingFeeValue') }}
                                />
                                <input
                                  className='search-input'
                                  value={suppliercardInfo?.amexSecondProcessingFeeValue || ''}
                                  onChange={(e) => { handleChangeCardInfo('amexSecondProcessingFeeValue', e.target.value, (!suppliercardInfo?.amexSecondProcessingFeeType || suppliercardInfo?.amexSecondProcessingFeeType === '$') ? 'currency' : 'percent') }}
                                  placeholder={(!suppliercardInfo?.amexSecondProcessingFeeType || suppliercardInfo?.amexSecondProcessingFeeType === '$') ? '1,234.00' : '12.50'}
                                />
                              </div>
                              <button className='ms-2 hide-option-btn' onClick={() => handleCardsSecondProcessingFeeValueChange('amex', 'amexSecondProcessingFeeType', 'amexSecondProcessingFeeValue')}> - </button>
                            </div>
                          </div>
                        )}
                      </div>
                      <div className='d-none d-sm-block'></div>
                    </div>
                  </div>
                  <div className="row g-0 flex-column flex-md-row">
                    <h4 className="name mb-0">Amex Minimum Payment:</h4>
                    <div className='processing-fee-parent gap-3 gap-sm-0 d-flex flex-column flex-sm-row'>
                      {showAmexMinFee ? (
                        <div className='flex processing-fee-dropdown-parent align-center'>
                          <div className='flex processing-fee-dropdown-child'>
                            <Select
                              className="processing-fee-dropdown h4 mb-0 no-zIndex"
                              options={
                                [
                                  {
                                    label: '$',
                                    value: '$',
                                  },
                                  {
                                    label: '%',
                                    value: '%',
                                  },
                                ]
                              }
                              value={{
                                label: suppliercardInfo?.amexMinPaymentFeeType || '$',
                                value: suppliercardInfo?.amexMinPaymentFeeType || '$',
                              }}
                              onChange={(item) => { handleUpdateCardFeeInfo('amexMinPaymentFeeType', item, 'feeValue', 'amexMinPaymentFeeValue') }}
                            />
                            <input
                              className='search-input'
                              value={suppliercardInfo?.amexMinPaymentFeeValue || ''}
                              onChange={(e) => { handleChangeCardInfo('amexMinPaymentFeeValue', e.target.value, (!suppliercardInfo?.amexMinPaymentFeeType || suppliercardInfo?.amexMinPaymentFeeType === '$') ? 'currency' : 'percent') }}
                              placeholder={(!suppliercardInfo?.amexMinPaymentFeeType || suppliercardInfo?.amexMinPaymentFeeType === '$') ? '1,234.00' : '12.50'}
                            />
                          </div>
                          <h4 className='flex-grow-1 text-center mb-0 text-black'>Fee if under</h4>
                        </div>
                      )
                        : <div></div>}
                      <div className='flex payment-parent'>
                        <div className="search-input-parent currency">
                          {suppliercardInfo?.americanExpressMinPaymnet ?
                            <span>$</span>
                            :
                            ''
                          }
                          <input
                            type="text"
                            className={`search-input ${suppliercardInfo?.americanExpressMinPaymnet ? 'has-value' : ''}`}
                            value={suppliercardInfo?.americanExpressMinPaymnet || ''}
                            onChange={(e) => { handleChangeCardInfo('americanExpressMinPaymnet', e.target.value, 'currency') }}
                            placeholder='$ 1,234.00'
                          />
                        </div>
                        {showAmexMinFee ?
                          <button className='hide-option' onClick={() => setShowAmexMinFee(false)}> - </button>
                          :
                          <button className='show-option' onClick={() => setShowAmexMinFee(true)}> + </button>
                        }
                      </div>
                    </div>
                  </div>
                  <div className="row g-0 flex-column flex-md-row">
                    <h4 className="name mb-0">Amex Maximum Payment:</h4>
                    <div className='processing-fee-parent gap-3 gap-sm-0 d-flex flex-column flex-sm-row'>
                      {showAmexMaxFee ? (
                        <div className='flex processing-fee-dropdown-parent align-center'>
                          <div className='flex processing-fee-dropdown-child'>
                            <Select
                              className="processing-fee-dropdown h4 mb-0 no-zIndex"
                              options={
                                [
                                  {
                                    label: '$',
                                    value: '$',
                                  },
                                  {
                                    label: '%',
                                    value: '%',
                                  },
                                ]
                              }
                              value={{
                                label: suppliercardInfo?.amexMaxPaymentFeeType || '$',
                                value: suppliercardInfo?.amexMaxPaymentFeeType || '$',
                              }}
                              onChange={(item) => { handleUpdateCardFeeInfo('amexMaxPaymentFeeType', item, 'feeValue', 'amexMaxPaymentFeeValue') }}
                            />
                            <input
                              className='search-input'
                              value={suppliercardInfo?.amexMaxPaymentFeeValue || ''}
                              onChange={(e) => { handleChangeCardInfo('amexMaxPaymentFeeValue', e.target.value, (!suppliercardInfo?.amexMaxPaymentFeeType || suppliercardInfo?.amexMaxPaymentFeeType === '$') ? 'currency' : 'percent') }}
                              placeholder={(!suppliercardInfo?.amexMaxPaymentFeeType || suppliercardInfo?.amexMaxPaymentFeeType === '$') ? '1,234.00' : '12.50'}
                            />
                          </div>
                          <h4 className='flex-grow-1 text-center mb-0 text-black'>Fee if over</h4>
                        </div>
                      )
                        : <div></div>}
                      <div className='flex payment-parent'>
                        <div className="search-input-parent currency">
                          {suppliercardInfo?.americanExpressMaxPayment ?
                            <span>$</span>
                            :
                            ''
                          }
                          <input
                            type="text"
                            className={`search-input ${suppliercardInfo?.americanExpressMaxPayment ? 'has-value' : ''}`}
                            value={suppliercardInfo?.americanExpressMaxPayment || ''}
                            onChange={(e) => { handleChangeCardInfo('americanExpressMaxPayment', e.target.value, 'currency') }}
                            placeholder='$ 1,234.00'
                          />
                        </div>
                        {showAmexMaxFee ?
                          <button className='hide-option' onClick={() => setShowAmexMaxFee(false)}> - </button>
                          :
                          <button className='show-option' onClick={() => setShowAmexMaxFee(true)}> + </button>
                        }
                      </div>
                    </div>
                  </div>
                  <div className="row g-0 flex-column flex-md-row">
                    <h4 className="name mb-0">Incremental Fee:</h4>
                    <div className='processing-fee-parent gap-3 gap-sm-0 d-flex flex-column flex-sm-row'>
                      {showAmexIncrementalFee ? (
                        <div className='flex processing-fee-dropdown-parent align-center'>
                          <div className='flex processing-fee-dropdown-child'>
                            <Select
                              className="processing-fee-dropdown h4 mb-0 no-zIndex"
                              options={
                                [
                                  {
                                    label: '$',
                                    value: '$',
                                  },
                                  {
                                    label: '%',
                                    value: '%',
                                  },
                                ]
                              }
                              value={{
                                label: suppliercardInfo?.amexIncrementalFeeType || '$',
                                value: suppliercardInfo?.amexIncrementalFeeType || '$',
                              }}
                              onChange={(item) => { handleUpdateCardFeeInfo('amexIncrementalFeeType', item, 'feeValue', 'amexIncrementalFeeValue') }}
                            />
                            <input
                              className='search-input'
                              value={suppliercardInfo?.amexIncrementalFeeValue || ''}
                              onChange={(e) => { handleChangeCardInfo('amexIncrementalFeeValue', e.target.value, (!suppliercardInfo?.amexIncrementalFeeType || suppliercardInfo?.amexIncrementalFeeType === '$') ? 'currency' : 'percent') }}
                              placeholder={(!suppliercardInfo?.amexIncrementalFeeType || suppliercardInfo?.amexIncrementalFeeType === '$') ? '1,234.00' : '12.50'}
                            />
                          </div>
                          <h4 className='flex-grow-1 text-center mb-0 text-black'>Fee for every</h4>
                        </div>
                      )
                        : <div></div>}
                      <div className='flex payment-parent'>
                        {showAmexIncrementalFee ? (
                          <div className="search-input-parent currency">
                            {suppliercardInfo?.amexIncrementalPaymentAmount ?
                              <span>$</span>
                              :
                              ''
                            }
                            <input
                              type="text"
                              className={`search-input ${suppliercardInfo?.amexIncrementalPaymentAmount ? 'has-value' : ''}`}
                              value={suppliercardInfo?.amexIncrementalPaymentAmount || ''}
                              onChange={(e) => { handleChangeCardInfo('amexIncrementalPaymentAmount', e.target.value, 'currency') }}
                              placeholder='$ 1,234.00'
                            />
                          </div>
                        )
                          : <div></div>}
                        {showAmexIncrementalFee ?
                          <button className='hide-option' onClick={() => setShowAmexIncrementalFee(false)}> - </button>
                          :
                          <button className='show-option' onClick={() => setShowAmexIncrementalFee(true)}> + </button>
                        }
                      </div>
                    </div>
                  </div>
                  <div className="item">
                    <h4 className='toggle-item-text mb-0'>Variable Fee:</h4>
                    <ThreeStateToggleButton onChange={(checked) => { setSuppliercardInfo({ ...suppliercardInfo, isAcceptAmexVariableFee: checked }) }} checked={suppliercardInfo?.isAcceptAmexVariableFee} />
                  </div>
                </div>
              )
            }

            <div className="item accepts-visa">
              <h4 className='fw-bold toggle-item-text mb-0'>Accepts Visa: <img className='item-image ms-0 ms-sm-3' src={VisaImg} /> </h4>
              <ThreeStateToggleButton onChange={handleToggleVisa} checked={showVisa} />
            </div>

            {
              showVisa && !suppliercardInfo?.advancedAcceptanceEnabled && (
                <div className="item processing-fee">
                  <h4 className='fw-bold mb-0'>Visa Conditions:</h4>
                  {showVisa ? (
                    <div className='flex processing-fee-parent align-items-center'>
                      <h4 className={`fw-bold mb-0${suppliercardInfo?.isAcceptVisaCardConditions ? '' : ' d-none'}`}>Fee</h4>
                      <div className='d-flex align-items-center'>
                        <h4 className={`fw-bold mb-0${suppliercardInfo?.isAcceptVisaCardConditions ? '' : ' d-none'}`}>Amount</h4>
                        <ThreeStateToggleButton customClass='ms-auto' onChange={(checked) => { handleCardConditionsChange('isAcceptVisaCardConditions', checked) }} checked={suppliercardInfo?.isAcceptVisaCardConditions} />
                      </div>
                    </div>
                  ) :
                    <div></div>}
                </div>
              )
            }
            {
              showVisa && !suppliercardInfo?.advancedAcceptanceEnabled && suppliercardInfo?.isAcceptVisaCardConditions && (
                <div className="fee-item">
                  <div className="row g-0 flex-column flex-md-row">
                    <h4 className="name mb-0">Visa Processing Fee</h4>
                    <div className='processing-fee-parent flex'>
                      <div className='flex processing-fee-dropdown-parent align-items-start align-center gap-2 flex-column'>
                        <div className='d-flex'>
                          <div className='flex processing-fee-dropdown-child flex-grow-1'>
                            <Select
                              menuMaxHeight={48}
                              className="processing-fee-dropdown h4 mb-0 no-zIndex"
                              options={
                                [
                                  {
                                    label: '$',
                                    value: '$',
                                  },
                                  {
                                    label: '%',
                                    value: '%',
                                  },
                                ]
                              }
                              value={{
                                label: suppliercardInfo?.visaProcessingFeeType || '$',
                                value: suppliercardInfo?.visaProcessingFeeType || '$',
                              }}
                              onChange={(item) => { handleUpdateCardFeeInfo('visaProcessingFeeType', item, 'feeValue', 'visaProcessingFeeValue') }}
                            />
                            <input
                              className='search-input'
                              value={suppliercardInfo?.visaProcessingFeeValue || ''}
                              onChange={(e) => { handleChangeCardInfo('visaProcessingFeeValue', e.target.value, (!suppliercardInfo?.visaProcessingFeeType || suppliercardInfo?.visaProcessingFeeType === '$') ? 'currency' : 'percent') }}
                              placeholder={(!suppliercardInfo?.visaProcessingFeeType || suppliercardInfo?.visaProcessingFeeType === '$') ? '1,234.00' : '12.50'}
                            />
                          </div>
                          <button className='ms-2 show-option-btn' disabled={(!suppliercardInfo?.visaProcessingFeeValue || showVisaAnotherProcessingFee) ? true : false} onClick={() => setShowVisaAnotherProcessingFee(true)}> + </button>
                        </div>

                        {showVisaAnotherProcessingFee && (
                          <div className='d-flex'>
                            <div className='flex processing-fee-dropdown-parent align-center'>
                              <div className='flex processing-fee-dropdown-child flex-grow-1'>
                                <Select // flex-sm-grow-0
                                  menuMaxHeight={48}
                                  className="processing-fee-dropdown h4 mb-0 no-zIndex"
                                  options={
                                    [
                                      {
                                        label: '$',
                                        value: '$',
                                      },
                                      {
                                        label: '%',
                                        value: '%',
                                      },
                                    ]
                                  }
                                  value={{
                                    label: suppliercardInfo?.visaSecondProcessingFeeType || '$',
                                    value: suppliercardInfo?.visaSecondProcessingFeeType || '$',
                                  }}
                                  onChange={(item) => { handleUpdateCardFeeInfo('visaSecondProcessingFeeType', item, 'feeValue', 'visaSecondProcessingFeeValue') }}
                                />
                                <input
                                  className='search-input'
                                  value={suppliercardInfo?.visaSecondProcessingFeeValue || ''}
                                  onChange={(e) => { handleChangeCardInfo('visaSecondProcessingFeeValue', e.target.value, (!suppliercardInfo?.visaSecondProcessingFeeType || suppliercardInfo?.visaSecondProcessingFeeType === '$') ? 'currency' : 'percent') }}
                                  placeholder={(!suppliercardInfo?.visaSecondProcessingFeeType || suppliercardInfo?.visaSecondProcessingFeeType === '$') ? '1,234.00' : '12.50'}
                                />
                              </div>
                              <button className='ms-2 hide-option-btn' onClick={() => handleCardsSecondProcessingFeeValueChange('visa', 'visaSecondProcessingFeeType', 'visaSecondProcessingFeeValue')}> - </button>
                            </div>
                          </div>
                        )}
                      </div>
                      <div className='d-none d-sm-block'></div>
                    </div>
                  </div>
                  <div className="row g-0 flex-column flex-md-row">
                    <h4 className="name mb-0">Visa Minimum Payment:</h4>
                    <div className='processing-fee-parent gap-3 gap-sm-0 d-flex flex-column flex-sm-row'>
                      {showVisaMinFee ? (
                        <div className='flex processing-fee-dropdown-parent align-center'>
                          <div className='flex processing-fee-dropdown-child'>
                            <Select
                              className="processing-fee-dropdown h4 mb-0 no-zIndex"
                              options={
                                [
                                  {
                                    label: '$',
                                    value: '$',
                                  },
                                  {
                                    label: '%',
                                    value: '%',
                                  },
                                ]
                              }
                              value={{
                                label: suppliercardInfo?.visaMinPaymentFeeType || '$',
                                value: suppliercardInfo?.visaMinPaymentFeeType || '$',
                              }}
                              onChange={(item) => { handleUpdateCardFeeInfo('visaMinPaymentFeeType', item, 'feeValue', 'visaMinPaymentFeeValue') }}
                            />
                            <input
                              className='search-input'
                              value={suppliercardInfo?.visaMinPaymentFeeValue || ''}
                              onChange={(e) => { handleChangeCardInfo('visaMinPaymentFeeValue', e.target.value, (!suppliercardInfo?.visaMinPaymentFeeType || suppliercardInfo?.visaMinPaymentFeeType === '$') ? 'currency' : 'percent') }}
                              placeholder={(!suppliercardInfo?.visaMinPaymentFeeType || suppliercardInfo?.visaMinPaymentFeeType === '$') ? '1,234.00' : '12.50'}
                            />
                          </div>
                          <h4 className='flex-grow-1 text-center mb-0 text-black'>Fee if under</h4>
                        </div>
                      )
                        : <div></div>}
                      <div className='flex payment-parent'>
                        <div className="search-input-parent currency">
                          {suppliercardInfo?.visaMinPayment ?
                            <span>$</span>
                            :
                            ''
                          }
                          <input
                            type="text"
                            className={`search-input ${suppliercardInfo?.visaMinPayment ? 'has-value' : ''}`}
                            value={suppliercardInfo?.visaMinPayment || ''}
                            onChange={(e) => { handleChangeCardInfo('visaMinPayment', e.target.value, 'currency') }}
                            placeholder='$ 1,234.00'
                          />
                        </div>
                        {showVisaMinFee ?
                          <button className='hide-option' onClick={() => setShowVisaMinFee(false)}> - </button>
                          :
                          <button className='show-option' onClick={() => setShowVisaMinFee(true)}> + </button>
                        }
                      </div>
                    </div>
                  </div>
                  <div className="row g-0 flex-column flex-md-row">
                    <h4 className="name mb-0">Visa Maximum Payment:</h4>
                    <div className='processing-fee-parent gap-3 gap-sm-0 d-flex flex-column flex-sm-row'>
                      {showVisaMaxFee ? (
                        <div className='flex processing-fee-dropdown-parent align-center'>
                          <div className='flex processing-fee-dropdown-child'>
                            <Select
                              className="processing-fee-dropdown h4 mb-0 no-zIndex"
                              options={
                                [
                                  {
                                    label: '$',
                                    value: '$',
                                  },
                                  {
                                    label: '%',
                                    value: '%',
                                  },
                                ]
                              }
                              value={{
                                label: suppliercardInfo?.visaMaxPaymentFeeType || '$',
                                value: suppliercardInfo?.visaMaxPaymentFeeType || '$',
                              }}
                              onChange={(item) => { handleUpdateCardFeeInfo('visaMaxPaymentFeeType', item, 'feeValue', 'visaMaxPaymentFeeValue') }}
                            />
                            <input
                              className='search-input'
                              value={suppliercardInfo?.visaMaxPaymentFeeValue || ''}
                              onChange={(e) => { handleChangeCardInfo('visaMaxPaymentFeeValue', e.target.value, (!suppliercardInfo?.visaMaxPaymentFeeType || suppliercardInfo?.visaMaxPaymentFeeType === '$') ? 'currency' : 'percent') }}
                              placeholder={(!suppliercardInfo?.visaMaxPaymentFeeType || suppliercardInfo?.visaMaxPaymentFeeType === '$') ? '1,234.00' : '12.50'}
                            />
                          </div>
                          <h4 className='flex-grow-1 text-center mb-0 text-black'>Fee if over</h4>
                        </div>
                      )
                        : <div></div>}
                      <div className='flex payment-parent'>
                        <div className="search-input-parent currency">
                          {suppliercardInfo?.visaMaxPayment ?
                            <span>$</span>
                            :
                            ''
                          }
                          <input
                            type="text"
                            className={`search-input ${suppliercardInfo?.visaMaxPayment ? 'has-value' : ''}`}
                            value={suppliercardInfo?.visaMaxPayment || ''}
                            onChange={(e) => { handleChangeCardInfo('visaMaxPayment', e.target.value, 'currency') }}
                            placeholder='$ 1,234.00'
                          />
                        </div>
                        {showVisaMaxFee ?
                          <button className='hide-option' onClick={() => setShowVisaMaxFee(false)}> - </button>
                          :
                          <button className='show-option' onClick={() => setShowVisaMaxFee(true)}> + </button>
                        }
                      </div>
                    </div>
                  </div>
                  <div className="row g-0 flex-column flex-md-row">
                    <h4 className="name mb-0">Incremental Fee:</h4>
                    <div className='processing-fee-parent gap-3 gap-sm-0 d-flex flex-column flex-sm-row'>
                      {showVisaIncrementalFee ? (
                        <div className='flex processing-fee-dropdown-parent align-center'>
                          <div className='flex processing-fee-dropdown-child'>
                            <Select
                              className="processing-fee-dropdown h4 mb-0 no-zIndex"
                              options={
                                [
                                  {
                                    label: '$',
                                    value: '$',
                                  },
                                  {
                                    label: '%',
                                    value: '%',
                                  },
                                ]
                              }
                              value={{
                                label: suppliercardInfo?.visaIncrementalFeeType || '$',
                                value: suppliercardInfo?.visaIncrementalFeeType || '$',
                              }}
                              onChange={(item) => { handleUpdateCardFeeInfo('visaIncrementalFeeType', item, 'feeValue', 'visaIncrementalFeeValue') }}
                            />
                            <input
                              className='search-input'
                              value={suppliercardInfo?.visaIncrementalFeeValue || ''}
                              onChange={(e) => { handleChangeCardInfo('visaIncrementalFeeValue', e.target.value, (!suppliercardInfo?.visaIncrementalFeeType || suppliercardInfo?.visaIncrementalFeeType === '$') ? 'currency' : 'percent') }}
                              placeholder={(!suppliercardInfo?.visaIncrementalFeeType || suppliercardInfo?.visaIncrementalFeeType === '$') ? '1,234.00' : '12.50'}
                            />
                          </div>
                          <h4 className='flex-grow-1 text-center mb-0 text-black'>Fee for every</h4>
                        </div>
                      )
                        : <div></div>}
                      <div className='flex payment-parent'>
                        {showVisaIncrementalFee ? (
                          <div className="search-input-parent currency">
                            {suppliercardInfo?.visaIncrementalPaymentAmount ?
                              <span>$</span>
                              :
                              ''
                            }
                            <input
                              type="text"
                              className={`search-input ${suppliercardInfo?.visaIncrementalPaymentAmount ? 'has-value' : ''}`}
                              value={suppliercardInfo?.visaIncrementalPaymentAmount || ''}
                              onChange={(e) => { handleChangeCardInfo('visaIncrementalPaymentAmount', e.target.value, 'currency') }}
                              placeholder='$ 1,234.00'
                            />
                          </div>
                        )
                          : <div></div>}
                        {showVisaIncrementalFee ?
                          <button className='hide-option' onClick={() => setShowVisaIncrementalFee(false)}> - </button>
                          :
                          <button className='show-option' onClick={() => setShowVisaIncrementalFee(true)}> + </button>
                        }
                      </div>
                    </div>
                  </div>
                  <div className="item">
                    <h4 className='toggle-item-text mb-0'>Variable Fee:</h4>
                    <ThreeStateToggleButton onChange={(checked) => { setSuppliercardInfo({ ...suppliercardInfo, isAcceptVisaVariableFee: checked }) }} checked={suppliercardInfo?.isAcceptVisaVariableFee} />
                  </div>
                </div>
              )
            }

            <div className="item accepts-mastercard">
              <h4 className='fw-bold toggle-item-text mb-0'>Accepts Mastercard: <img className='item-image ms-0 ms-sm-3' src={MasterCardImg} /></h4>
              <ThreeStateToggleButton onChange={handleToggleMaster} checked={showMaster} />
            </div>

            {
              showMaster && !suppliercardInfo?.advancedAcceptanceEnabled && (
                <div className="item processing-fee">
                  <h4 className='fw-bold mb-0'>Mastercard Conditions:</h4>
                  {showMaster ? (
                    <div className='flex processing-fee-parent align-items-center'>
                      <h4 className={`fw-bold mb-0${suppliercardInfo?.isAcceptMastercardCardConditions ? '' : ' d-none'}`}>Fee</h4>
                      <div className='d-flex align-items-center'>
                        <h4 className={`fw-bold mb-0${suppliercardInfo?.isAcceptMastercardCardConditions ? '' : ' d-none'}`}>Amount</h4>
                        <ThreeStateToggleButton customClass='ms-auto' onChange={(checked) => { handleCardConditionsChange('isAcceptMastercardCardConditions', checked) }} checked={suppliercardInfo?.isAcceptMastercardCardConditions} />
                      </div>
                    </div>
                  ) :
                    <div></div>}
                </div>
              )
            }
            {
              showMaster && !suppliercardInfo?.advancedAcceptanceEnabled && suppliercardInfo?.isAcceptMastercardCardConditions && (
                <div className="fee-item">
                  <div className="row g-0 flex-column flex-md-row">
                    <h4 className="name mb-0">Mastercard Processing Fee</h4>
                    <div className='processing-fee-parent flex'>
                      <div className='flex processing-fee-dropdown-parent align-items-start align-center gap-2 flex-column'>
                        <div className='d-flex'>
                          <div className='flex processing-fee-dropdown-child flex-grow-1'>
                            <Select
                              menuMaxHeight={48}
                              className="processing-fee-dropdown h4 mb-0 no-zIndex"
                              options={
                                [
                                  {
                                    label: '$',
                                    value: '$',
                                  },
                                  {
                                    label: '%',
                                    value: '%',
                                  },
                                ]
                              }
                              value={{
                                label: suppliercardInfo?.mastercardProcessingFeeType || '$',
                                value: suppliercardInfo?.mastercardProcessingFeeType || '$',
                              }}
                              onChange={(item) => { handleUpdateCardFeeInfo('mastercardProcessingFeeType', item, 'feeValue', 'mastercardProcessingFeeValue') }}
                            />
                            <input
                              className='search-input'
                              value={suppliercardInfo?.mastercardProcessingFeeValue || ''}
                              onChange={(e) => { handleChangeCardInfo('mastercardProcessingFeeValue', e.target.value, (!suppliercardInfo?.mastercardProcessingFeeType || suppliercardInfo?.mastercardProcessingFeeType === '$') ? 'currency' : 'percent') }}
                              placeholder={(!suppliercardInfo?.mastercardProcessingFeeType || suppliercardInfo?.mastercardProcessingFeeType === '$') ? '1,234.00' : '12.50'}
                            />
                          </div>
                          <button className='ms-2 show-option-btn' disabled={(!suppliercardInfo?.mastercardProcessingFeeValue || showMasterAnotherProcessingFee) ? true : false} onClick={() => setShowMasterAnotherProcessingFee(true)}> + </button>
                        </div>

                        {showMasterAnotherProcessingFee && (
                          <div className='d-flex'>
                            <div className='flex processing-fee-dropdown-parent align-center'>
                              <div className='flex processing-fee-dropdown-child flex-grow-1'>
                                <Select // flex-sm-grow-0
                                  menuMaxHeight={48}
                                  className="processing-fee-dropdown h4 mb-0 no-zIndex"
                                  options={
                                    [
                                      {
                                        label: '$',
                                        value: '$',
                                      },
                                      {
                                        label: '%',
                                        value: '%',
                                      },
                                    ]
                                  }
                                  value={{
                                    label: suppliercardInfo?.mastercardSecondProcessingFeeType || '$',
                                    value: suppliercardInfo?.mastercardSecondProcessingFeeType || '$',
                                  }}
                                  onChange={(item) => { handleUpdateCardFeeInfo('mastercardSecondProcessingFeeType', item, 'feeValue', 'mastercardSecondProcessingFeeValue') }}
                                />
                                <input
                                  className='search-input'
                                  value={suppliercardInfo?.mastercardSecondProcessingFeeValue || ''}
                                  onChange={(e) => { handleChangeCardInfo('mastercardSecondProcessingFeeValue', e.target.value, (!suppliercardInfo?.mastercardSecondProcessingFeeType || suppliercardInfo?.mastercardSecondProcessingFeeType === '$') ? 'currency' : 'percent') }}
                                  placeholder={(!suppliercardInfo?.mastercardSecondProcessingFeeType || suppliercardInfo?.mastercardSecondProcessingFeeType === '$') ? '1,234.00' : '12.50'}
                                />
                              </div>
                              <button className='ms-2 hide-option-btn' onClick={() => handleCardsSecondProcessingFeeValueChange('master', 'mastercardSecondProcessingFeeType', 'mastercardSecondProcessingFeeValue')}> - </button>
                            </div>
                          </div>
                        )}
                      </div>
                      <div className='d-none d-sm-block'></div>
                    </div>
                  </div>
                  <div className="row g-0 flex-column flex-md-row">
                    <h4 className="name mb-0">Mastercard Minimum Payment:</h4>
                    <div className='processing-fee-parent gap-3 gap-sm-0 d-flex flex-column flex-sm-row'>
                      {showMasterMinFee ? (
                        <div className='flex processing-fee-dropdown-parent align-center'>
                          <div className='flex processing-fee-dropdown-child'>
                            <Select
                              className="processing-fee-dropdown h4 mb-0 no-zIndex"
                              options={
                                [
                                  {
                                    label: '$',
                                    value: '$',
                                  },
                                  {
                                    label: '%',
                                    value: '%',
                                  },
                                ]
                              }
                              value={{
                                label: suppliercardInfo?.mastercardMinPaymentFeeType || '$',
                                value: suppliercardInfo?.mastercardMinPaymentFeeType || '$',
                              }}
                              onChange={(item) => { handleUpdateCardFeeInfo('mastercardMinPaymentFeeType', item, 'feeValue', 'mastercardMinPaymentFeeValue') }}
                            />
                            <input
                              className='search-input'
                              value={suppliercardInfo?.mastercardMinPaymentFeeValue || ''}
                              onChange={(e) => { handleChangeCardInfo('mastercardMinPaymentFeeValue', e.target.value, (!suppliercardInfo?.mastercardMinPaymentFeeType || suppliercardInfo?.mastercardMinPaymentFeeType === '$') ? 'currency' : 'percent') }}

                              placeholder={(!suppliercardInfo?.mastercardMinPaymentFeeType || suppliercardInfo?.mastercardMinPaymentFeeType === '$') ? '1,234.00' : '12.50'}
                            />
                          </div>
                          <h4 className='flex-grow-1 text-center mb-0 text-black'>Fee if under</h4>
                        </div>
                      )
                        : <div></div>}
                      <div className='flex payment-parent'>
                        <div className="search-input-parent currency">
                          {suppliercardInfo?.mastercardMinPayment ?
                            <span>$</span>
                            :
                            ''
                          }
                          <input
                            type="text"
                            className={`search-input ${suppliercardInfo?.mastercardMinPayment ? 'has-value' : ''}`}
                            value={suppliercardInfo?.mastercardMinPayment || ''}
                            onChange={(e) => { handleChangeCardInfo('mastercardMinPayment', e.target.value.replace(/\$\s/g, ''), 'currency') }}
                            placeholder='$ 1,234.00'
                          />
                        </div>
                        {showMasterMinFee ?
                          <button className='hide-option' onClick={() => setShowMasterMinFee(false)}> - </button>
                          :
                          <button className='show-option' onClick={() => setShowMasterMinFee(true)}> + </button>
                        }
                      </div>
                    </div>
                  </div>
                  <div className="row g-0 flex-column flex-md-row">
                    <h4 className="name mb-0">Mastercard Maximum Payment:</h4>
                    <div className='processing-fee-parent gap-3 gap-sm-0 d-flex flex-column flex-sm-row'>
                      {showMasterMaxFee ? (
                        <div className='flex processing-fee-dropdown-parent align-center'>
                          <div className='flex processing-fee-dropdown-child'>
                            <Select
                              className="processing-fee-dropdown h4 mb-0 no-zIndex"
                              options={
                                [
                                  {
                                    label: '$',
                                    value: '$',
                                  },
                                  {
                                    label: '%',
                                    value: '%',
                                  },
                                ]
                              }
                              value={{
                                label: suppliercardInfo?.mastercardMaxPaymentFeeType || '$',
                                value: suppliercardInfo?.mastercardMaxPaymentFeeType || '$',
                              }}
                              onChange={(item) => { handleUpdateCardFeeInfo('mastercardMaxPaymentFeeType', item, 'feeValue', 'mastercardMaxPaymentFeeValue') }}
                            />
                            <input
                              className='search-input'
                              value={suppliercardInfo?.mastercardMaxPaymentFeeValue || ''}
                              onChange={(e) => { handleChangeCardInfo('mastercardMaxPaymentFeeValue', e.target.value, (!suppliercardInfo?.mastercardMaxPaymentFeeType || suppliercardInfo?.mastercardMaxPaymentFeeType === '$') ? 'currency' : 'percent') }}
                              placeholder={(!suppliercardInfo?.mastercardMaxPaymentFeeType || suppliercardInfo?.mastercardMaxPaymentFeeType === '$') ? '1,234.00' : '12.50'}
                            />
                          </div>
                          <h4 className='flex-grow-1 text-center mb-0 text-black'>Fee if over</h4>
                        </div>
                      )
                        : <div></div>}
                      <div className='flex payment-parent'>
                        <div className="search-input-parent currency">
                          {suppliercardInfo?.mastercardMaxPayment ?
                            <span>$</span>
                            :
                            ''
                          }
                          <input
                            type="text"
                            className={`search-input ${suppliercardInfo?.mastercardMaxPayment ? 'has-value' : ''}`}
                            value={suppliercardInfo?.mastercardMaxPayment || ''}
                            onChange={(e) => { handleChangeCardInfo('mastercardMaxPayment', e.target.value, 'currency') }}
                            placeholder='$ 1,234.00'
                          />
                        </div>
                        {showMasterMaxFee ?
                          <button className='hide-option' onClick={() => setShowMasterMaxFee(false)}> - </button>
                          :
                          <button className='show-option' onClick={() => setShowMasterMaxFee(true)}> + </button>
                        }
                      </div>
                    </div>
                  </div>
                  <div className="row g-0 flex-column flex-md-row">
                    <h4 className="name mb-0">Incremental Fee:</h4>
                    <div className='processing-fee-parent gap-3 gap-sm-0 d-flex flex-column flex-sm-row'>
                      {showMasterIncrementalFee ? (
                        <div className='flex processing-fee-dropdown-parent align-center'>
                          <div className='flex processing-fee-dropdown-child'>
                            <Select
                              className="processing-fee-dropdown h4 mb-0 no-zIndex"
                              options={
                                [
                                  {
                                    label: '$',
                                    value: '$',
                                  },
                                  {
                                    label: '%',
                                    value: '%',
                                  },
                                ]
                              }
                              value={{
                                label: suppliercardInfo?.mastercardIncrementalFeeType || '$',
                                value: suppliercardInfo?.mastercardIncrementalFeeType || '$',
                              }}
                              onChange={(item) => { handleUpdateCardFeeInfo('mastercardIncrementalFeeType', item, 'feeValue', 'mastercardIncrementalFeeValue') }}
                            />
                            <input
                              className='search-input'
                              value={suppliercardInfo?.mastercardIncrementalFeeValue || ''}
                              onChange={(e) => { handleChangeCardInfo('mastercardIncrementalFeeValue', e.target.value, (!suppliercardInfo?.mastercardIncrementalFeeType || suppliercardInfo?.mastercardIncrementalFeeType === '$') ? 'currency' : 'percent') }}
                              placeholder={(!suppliercardInfo?.mastercardIncrementalFeeType || suppliercardInfo?.mastercardIncrementalFeeType === '$') ? '1,234.00' : '12.50'}
                            />
                          </div>
                          <h4 className='flex-grow-1 text-center mb-0 text-black'>Fee for every</h4>
                        </div>
                      )
                        : <div></div>}
                      <div className='flex payment-parent'>
                        {showMasterIncrementalFee ? (
                          <div className="search-input-parent currency">
                            {suppliercardInfo?.mastercardIncrementalPaymentAmount ?
                              <span>$</span>
                              :
                              ''
                            }
                            <input
                              type="text"
                              className={`search-input ${suppliercardInfo?.mastercardIncrementalPaymentAmount ? 'has-value' : ''}`}
                              value={suppliercardInfo?.mastercardIncrementalPaymentAmount || ''}
                              onChange={(e) => { handleChangeCardInfo('mastercardIncrementalPaymentAmount', e.target.value, 'currency') }}
                              placeholder='$ 1,234.00'
                            />
                          </div>
                        )
                          : <div></div>}
                        {showMasterIncrementalFee ?
                          <button className='hide-option' onClick={() => setShowMasterIncrementalFee(false)}> - </button>
                          :
                          <button className='show-option' onClick={() => setShowMasterIncrementalFee(true)}> + </button>
                        }
                      </div>
                    </div>
                  </div>
                  <div className="item">
                    <h4 className='toggle-item-text mb-0'>Variable Fee:</h4>
                    <ThreeStateToggleButton onChange={(checked) => { setSuppliercardInfo({ ...suppliercardInfo, isAcceptMasterCardVariableFee: checked }) }} checked={suppliercardInfo?.isAcceptMasterCardVariableFee} />
                  </div>
                </div>
              )
            }
          </>
        }

        {
          (showAmex || showVisa || showMaster) && (
            <>
              {((Object.keys(deliveryMethodFeeValues).length === 0 || totalDeliveryMethods <= 1) || !suppliercardInfo?.advancedAcceptanceEnabled) && (
                <>
                  <div className="item token-configuration">
                    <h4 className='fw-bold mb-0'>Token Configuration</h4>
                  </div>
                  <div className='item token-configuration-options-list'>
                    <RadioGroup name="radioList" className='fledx' inline={true} value={tokenConfigurationValue}>
                      <Radio value="single-use-max-amount" onChange={() => handleCardAuthorizationFormChange('single-use-max-amount')}>Single-Use Max Amount</Radio>
                      <Radio value="multi-use" onChange={() => handleCardAuthorizationFormChange('multi-use')}>Multi-Use</Radio>
                      <Radio value="reloadable" onChange={() => handleCardAuthorizationFormChange('reloadable')}>Reloadable</Radio>
                    </RadioGroup>
                  </div>
                </>
              )}

              <div className='item card-authorization-form direct-col'>
                <CheckboxComponent
                  label='Card Authorization Form'
                  onChange={() => { handleReceivePaymentCheckbox('isAcceptCardAuthorizationForm') }}
                  checked={suppliercardInfo.isAcceptCardAuthorizationForm}
                />
                {suppliercardInfo.isAcceptCardAuthorizationForm && (
                  <div className="accept-item">
                    <DragDropFileUpload
                      currentFileName={cardAuthorizationFormFile ? cardAuthorizationFormFile.name : suppliercardInfo?.cardAuthorizationFormFile}
                      onFileChosen={handleFileChosen}
                      customClassName='upload-card-authorization-form-file'
                      accept='*.*'
                      isDownload={(suppliercardInfo?.cardAuthorizationFormFile && cardAuthorizationFormFile === null) ? true : false}
                    />
                  </div>
                )}

              </div>

              <div className="item d-block">
                <h4 className='fw-bold mb-0'>How Do They Receive Payment:</h4>
                <div className='receive-payment-container'>
                  <div className='receive-payment-item'>
                    <div className={`d-flex align-items-center`}>
                      <CheckboxComponent
                        label='Email'
                        onChange={() => { handleReceivePaymentCheckbox('isAcceptCardPaymentByEmail') }}
                        checked={suppliercardInfo.isAcceptCardPaymentByEmail}
                      />
                      {suppliercardInfo.isAcceptCardPaymentByEmail && (
                        getRemittanceRequirements('emailRemitRequirements')
                      )}
                    </div>
                    {suppliercardInfo.isAcceptCardPaymentByEmail && (
                      <>
                        <div className={`add-more-email-container d-flex flex-column flex-sm-row align-items-start align-items-sm-center mt-2 position-relative${suppliercardEmailsInfo?.[0]?.emailContactId ? ' input-group h-100 align-items-center' : ''}`}>
                          {suppliercardEmailsInfo?.[0]?.emailContactId && (
                            <span role='button' class='border-end-0 input-group-text text-red px-3 fs-2 fw-bold mt-2 mb-0' onClick={() => { handleRemoveContact('email') }} style={{ height: '48px' }}>X</span>
                          )}
                          <input
                            type="text"
                            style={{ marginLeft: suppliercardEmailsInfo?.[0]?.emailContactId ? '-20px' : '0' }}
                            className={`search-input text-primary`}
                            value={suppliercardEmailsInfo?.[0]?.email || ''}
                            onChange={e => handleEmailsChange(e, 0)}
                            placeholder='email@gmail.com'
                            onClick={() => { onPhoneEmailClick('email', 'phone', 'ivrPhone') }}
                            onMouseOver={(e) => { onContactMouseHover(e) }}
                            onMouseOut={(e) => { onContactMouseHoverOut(e) }}
                            // onBlur={() => { handleEmailFocusOut(suppliercardEmailsInfo?.[0]) }}
                            autoComplete='no-email'
                            data-contact-id={suppliercardEmailsInfo?.[0]?.emailContactId || ''}
                          />
                          {suppliercardEmailsInfo?.[0]?.email && !showAllContacts?.email && (
                            <ContactView contact={currentContact} />
                          )}
                          {showAllContacts?.email && (
                            <AllContacts contacts={existedContacts} onClose={onPhoneEmailFocusOutClick} onCreateContact={handleOnCreateContact} supplierId={masterSupplierDetails?.baseInfo?.id} isLoading={isLoadingExistingContacts} onContactClick={handleContactClick} onGetContactsData={onGetContactsData} />
                          )}
                          {isValidatingEmail && suppliercardEmailsInfo?.[0]?.email && (<Loader />)}
                          {suppliercardEmailsInfo?.[0]?.email && !isValidatingEmail && isEmailValid !== '' &&
                            (isEmailRisky ?
                              <BsCheckSquare color="#EFD700" size={26} />
                              : isEmailValid ?
                                <BsCheckSquare color="#067911" size={26} />
                                :
                                <>
                                  <BsXSquare color="#f75a52" size={26} />
                                  <MdOutlineChangeCircle
                                    title='Retry'
                                    role='button'
                                    color="#14438b"
                                    size={30}
                                    onClick={() => { handleEmailFocusOut(suppliercardEmailsInfo?.[0]?.email, false, false, {}, true) }}
                                  />
                                </>
                            )
                          }
                          <Select
                            className="card-email-type-selector h4 mb-0"
                            options={
                              [
                                {
                                  label: 'Remittance',
                                  value: 'Remittance',
                                },
                                {
                                  label: 'Payment',
                                  value: 'Payment',
                                },
                              ]
                            }
                            value={{
                              label: cardEmailType || '',
                              value: cardEmailType || '',
                            }}
                            onChange={item => handleChangeCardEmailType(item.value)}
                          />
                          <button className='add-more-email flex align-center' onClick={addMoreEmail}>
                            <AiOutlinePlusCircle color="#65B3E9" size={26} />
                            Add
                          </button>
                        </div>
                        {emailValues.length > 0 && (
                          emailValues.every((email) => { return email === undefined }) ? '' : <h4 className='addedEmails fw-bold mb-0'> Added Emails : </h4>
                        )}
                        {emailValues.map((value, index) => {
                          if (typeof (value) !== 'undefined') {
                            return (
                              <div key={index} className="phone-input-parent card-acceptance-more-emails-container">
                                <h4 className='email-type fw-bold mb-0'> <i>{value?.["extra-email-name-" + (index + 1)]?.emailType === 'Remittance' ? 'Remittance' : 'Payment'} : </i></h4>
                                <div key={"extar-email-key" + (index + 1)} className="mt-2 card-acceptance-more-emails d-flex align-items-center flex-wrap gap-3 gap-sm-4 position-relative">
                                  <input
                                    role="button"
                                    className={"text-primary mt-0 search-input extra-email-" + (index + 1)}
                                    type="text"
                                    name={"extra-email-name-" + (index + 1)}
                                    value={value?.["extra-email-name-" + (index + 1)]?.email || ''}
                                    disabled={true}
                                    onMouseOver={(e) => { onContactMouseHover(e) }}
                                    onMouseOut={(e) => { onContactMouseHoverOut(e) }}
                                    data-contact-id={value?.["extra-email-name-" + (index + 1)]?.emailContactId || ''}
                                  ></input>
                                  {value?.["extra-email-name-" + (index + 1)]?.email && (
                                    <ContactView contact={currentContact} />
                                  )}
                                  {value?.["extra-email-name-" + (index + 1)]?.email && value?.["extra-email-name-" + (index + 1)]?.valid !== '' &&
                                    (value?.["extra-email-name-" + (index + 1)]?.risky ?
                                      <BsCheckSquare color="#EFD700" size={26} />
                                      :
                                      value?.["extra-email-name-" + (index + 1)]?.valid ?
                                        <BsCheckSquare color="#067911" size={26} />
                                        :
                                        <>
                                          <BsXSquare color="#f75a52" size={26} />
                                          <MdOutlineChangeCircle
                                            title='Retry'
                                            role='button'
                                            color="#14438b"
                                            size={30}
                                            onClick={() => { handleEmailFocusOut(value?.["extra-email-name-" + (index + 1)]?.email, false, false, {}, true) }}
                                          />
                                        </>
                                    )
                                  }
                                  <button className='remove-email flex align-center' onClick={() => removeEmail((index + 1))}>
                                    Remove
                                  </button>
                                </div>
                              </div>
                            );
                          }
                        })}
                      </>
                    )}
                  </div>
                  <div className='receive-payment-item'>
                    <div className={`d-flex align-items-center`}>
                      <CheckboxComponent
                        label='Phone'
                        onChange={() => { handleReceivePaymentCheckbox('isAcceptCardPaymentByPhone') }}
                        checked={suppliercardInfo.isAcceptCardPaymentByPhone}
                      />
                      {suppliercardInfo.isAcceptCardPaymentByPhone && (
                        getRemittanceRequirements('phoneRemitRequirements')
                      )}
                    </div>
                    {suppliercardInfo.isAcceptCardPaymentByPhone && (
                      <>
                        <div className='receive-payment-portals d-flex flex-wrap'>
                          <CheckboxComponent
                            label='POTS'
                            onChange={() => { handleReceivePaymentCheckbox('isAcceptPOTSPhone') }}
                            checked={suppliercardInfo?.isAcceptPOTSPhone}
                          />
                          <CheckboxComponent
                            label='IVR'
                            onChange={() => { handleReceivePaymentCheckbox('isAcceptIVRPhone') }}
                            checked={suppliercardInfo?.isAcceptIVRPhone}
                          />
                        </div>
                        {suppliercardInfo?.isAcceptPOTSPhone && (
                          <div className="phone-input-parent flex justify-content-center flex-column">
                            <h4 className='fw-bold mb-0'>POTS</h4>
                            <div className='d-flex align-center gap-2 position-relative'>
                              <div className={`d-flex border rounded w-50 flex-column flex-lg-row phone-input-ext-container position-relative${suppliercardInfo?.phoneContactId ? ' input-group' : ''}`}>
                                {suppliercardInfo?.phoneContactId && (
                                  <span role='button' class='border border-start-0 border-top-0 border-bottom-0 input-group-text text-red px-3 fs-2 fw-bold mb-0' onClick={() => { handleRemoveContact('phone') }} style={{ height: '48px' }}>X</span>
                                )}
                                <input
                                  onClick={() => { onPhoneEmailClick('phone', 'email', 'ivrPhone') }}
                                  value={suppliercardInfo?.cardPaymentByPhoneValue || ''}
                                  className={`basicvalue text-primary border-0 ms-0`}
                                  onChange={e => handlePhoneInputChange(e.target.value, null, e, null, 'cardPaymentByPhoneValue')}
                                  onMouseOver={(e) => { onContactMouseHover(e) }}
                                  onMouseOut={(e) => { onContactMouseHoverOut(e) }}
                                  data-contact-id={suppliercardInfo?.phoneContactId || ''}
                                  autoComplete='no-phone'
                                // onBlur={(event) => { isPhoneValid === '' && handlePhoneNumberFocusOut(event, null, supplierInfo[col.name]) }}
                                />
                                {/* <ReactPhoneInput
                                  country="us"
                                  value={suppliercardInfo?.cardPaymentByPhoneValue || ''}
                                  onChange={(value, country, e, formattedValue) => { handlePhoneInputChange(value, country, e, formattedValue, 'cardPaymentByPhoneValue') }}
                                  onBlur={(event, country) => { isPhoneValid === '' && handlePhoneNumberFocusOut(event, country, suppliercardInfo?.cardPaymentByPhoneValue, 'cardPaymentByPhoneValue') }}
                                  countryCodeEditable={false}
                                  preferredCountries={['us']}
                                  onKeyDown={(e) => handleKeyDown(e, phoneInputRefname)}
                                  ref={phoneInputRefname}
                                  className='flex-grow-1 flex-sm-grow-0 mt-0'
                                  buttonClass='border-0 border-end border-dark'
                                  inputProps={{
                                    role: "button",
                                    className: 'form-control border-0 shadow-none text-primary',
                                    onMouseOver: (e) => { onContactMouseHover(e) },
                                    onMouseOut: (e) => { onContactMouseHoverOut(e) },
                                    'data-contact-id': masterSupplierDetails?.cardInfo?.cardPaymentByPhoneValue || '',
                                  }}
                                /> */}
                                {suppliercardInfo?.cardPaymentByPhoneValue && !showAllContacts?.phone && (
                                  <ContactView contact={currentContact} />
                                )}
                                {showAllContacts?.phone && (
                                  <AllContacts contacts={existedContacts} onClose={onPhoneEmailFocusOutClick} onCreateContact={handleOnCreateContact} supplierId={masterSupplierDetails?.baseInfo?.id} isLoading={isLoadingExistingContacts} onContactClick={handleContactClick} onGetContactsData={onGetContactsData} />
                                )}
                                <div className="input-group phone-extension-container mb-0 flex-nowrap flex-grow-1">
                                  <span className="h4 mb-0 d-flex text-dark align-items-center border-0 border-start border-dark rounded-0 bg-white" id="phone_ext">Ext.</span>
                                  <input
                                    type="text"
                                    className="search-input mt-0 shadow-none form-control w-auto border-0 ps-3 pe-3"
                                    placeholder="phone extension"
                                    value={suppliercardInfo?.cardPhoneExtension || ''}
                                    onChange={(e) => { handleChangeReceivePaymentInfo('extension', 'cardPhoneExtension', e.target.value) }}
                                    disabled={(!suppliercardInfo?.cardPaymentByPhoneValue || !isPhoneValid || suppliercardInfo?.cardPaymentByPhoneValue === countryCode) ? true : false}
                                  />
                                </div>
                              </div>
                              {isValidatingPhone && (<Loader />)}
                              {suppliercardInfo?.cardPaymentByPhoneValue && !isValidatingPhone && isPhoneValid !== '' &&
                                (isPhoneValid ?
                                  <BsCheckSquare color="#067911" size={26} />
                                  :
                                  <BsXSquare color="#f75a52" size={26} />
                                )
                              }
                            </div>
                          </div>
                        )}
                        {suppliercardInfo?.isAcceptIVRPhone && (
                          <div className="phone-input-parent flex justify-content-center flex-column mt-4">
                            <h4 className='fw-bold mb-0'>IVR</h4>
                            <div className='d-flex align-center gap-2 position-relative'>
                              <div className={`d-flex border rounded w-50 flex-column flex-lg-row phone-input-ext-container position-relative${suppliercardInfo?.ivrPhoneContactId ? ' input-group' : ''}`}>
                                {suppliercardInfo?.ivrPhoneContactId && (
                                  <span role='button' class='border border-start-0 border-top-0 border-bottom-0 input-group-text text-red px-3 fs-2 fw-bold mb-0' onClick={() => { handleRemoveContact('ivrPhone') }}>X</span>
                                )}
                                <input
                                  value={suppliercardInfo?.cardPaymentIVRPhone || ''}
                                  className={`search-input basicvalue text-primary border-0 ms-0`}
                                  onChange={e => handlePhoneInputChange(e.target.value, null, e, null, 'cardPaymentIVRPhone')}
                                  onClick={() => { onPhoneEmailClick('ivrPhone', 'email', 'phone') }}
                                  onMouseOver={(e) => { onContactMouseHover(e) }}
                                  onMouseOut={(e) => { onContactMouseHoverOut(e) }}
                                  data-contact-id={suppliercardInfo?.ivrPhoneContactId || ''}
                                  autoComplete='no-phone'
                                // onBlur={(event) => { isPhoneValid === '' && handlePhoneNumberFocusOut(event, null, supplierInfo[col.name]) }}
                                />
                                {/* <ReactPhoneInput
                                  country="us"
                                  value={suppliercardInfo?.cardPaymentIVRPhone || ''}
                                  onChange={(value, country, e, formattedValue) => { handlePhoneInputChange(value, country, e, formattedValue, 'cardPaymentIVRPhone') }}
                                  onBlur={(event, country) => { isIVRPhoneValid === '' && handlePhoneNumberFocusOut(event, country, suppliercardInfo?.cardPaymentIVRPhone, 'cardPaymentIVRPhone') }}
                                  countryCodeEditable={false}
                                  preferredCountries={['us']}
                                  onKeyDown={(e) => handleKeyDown(e, ivrPhoneInputRefname)}
                                  ref={ivrPhoneInputRefname}
                                  className='flex-grow-1 flex-sm-grow-0 mt-0 w-100'
                                  buttonClass='border-0 border-end border-dark'
                                  inputProps={{
                                    role: "button",
                                    className: 'form-control border-0 shadow-none text-primary',
                                    onMouseOver: (e) => { onContactMouseHover(e) },
                                    onMouseOut: (e) => { onContactMouseHoverOut(e) },
                                    'data-contact-id': masterSupplierDetails?.cardInfo?.cardPaymentIVRPhone || '',
                                  }}
                                /> */}
                                {suppliercardInfo?.cardPaymentIVRPhone && !showAllContacts?.ivrPhone && (
                                  <ContactView contact={currentContact} />
                                )}
                                {showAllContacts?.ivrPhone && (
                                  <AllContacts contacts={existedContacts} onClose={onPhoneEmailFocusOutClick} onCreateContact={handleOnCreateContact} supplierId={masterSupplierDetails?.baseInfo?.id} isLoading={isLoadingExistingContacts} onContactClick={handleContactClick} onGetContactsData={onGetContactsData} />
                                )}
                              </div>
                              {isValidatingIVRPhone && (<Loader />)}
                              {suppliercardInfo?.cardPaymentIVRPhone && !isValidatingIVRPhone && isIVRPhoneValid !== '' &&
                                (isIVRPhoneValid ?
                                  <BsCheckSquare color="#067911" size={26} />
                                  :
                                  <BsXSquare color="#f75a52" size={26} />
                                )
                              }
                            </div>
                          </div>
                        )}
                      </>
                    )}
                  </div>
                  <div className='receive-payment-item'>
                    <div className={`d-flex align-items-center`}>
                      <CheckboxComponent
                        label='Fax'
                        onChange={() => { handleReceivePaymentCheckbox('isAcceptCardPaymentByFax') }}
                        checked={suppliercardInfo.isAcceptCardPaymentByFax}
                      />
                      {suppliercardInfo.isAcceptCardPaymentByFax && (
                        getRemittanceRequirements('faxRemitRequirements')
                      )}
                    </div>
                    {suppliercardInfo.isAcceptCardPaymentByFax && (
                      <input
                        type="text"
                        className="search-input"
                        value={suppliercardInfo?.cardPaymentByFaxValue || ''}
                        onChange={(e) => { handleChangeReceivePaymentInfo('fax', 'cardPaymentByFaxValue', e.target.value) }}
                        placeholder='786-874-5678'
                      />
                    )}
                  </div>
                  <div className='receive-payment-item'>
                    <div className={`d-flex align-items-center`}>
                      <CheckboxComponent
                        label='Online'
                        onChange={() => { handleReceivePaymentCheckbox('isAcceptCardPaymentByOnlinePortal') }}
                        checked={suppliercardInfo.isAcceptCardPaymentByOnlinePortal}
                      />
                      {suppliercardInfo.isAcceptCardPaymentByOnlinePortal && (
                        getRemittanceRequirements('onlineRemitRequirements')
                      )}
                    </div>
                    {suppliercardInfo.isAcceptCardPaymentByOnlinePortal && (
                      <div className='receive-payment-portals d-flex flex-wrap'>
                        <CheckboxComponent
                          label='E-commerce'
                          onChange={() => { handleReceivePaymentCheckbox('isAcceptEcommercePortal') }}
                          checked={suppliercardInfo.isAcceptEcommercePortal}
                        />
                        <CheckboxComponent
                          label='Portal'
                          onChange={() => { handleReceivePaymentCheckbox('isAcceptPortal') }}
                          checked={suppliercardInfo.isAcceptPortal}
                        />
                        <CheckboxComponent
                          label='3rd Party Portal'
                          onChange={() => { handleReceivePaymentCheckbox('isAccept3rdPartyPortal') }}
                          checked={suppliercardInfo.isAccept3rdPartyPortal}
                        />
                        <CheckboxComponent
                          label='In-App'
                          onChange={() => { handleReceivePaymentCheckbox('isAcceptInAppPortal') }}
                          checked={suppliercardInfo.isAcceptInAppPortal}
                        />
                      </div>
                    )}
                    {suppliercardInfo.isAcceptCardPaymentByOnlinePortal && suppliercardInfo.isAcceptPortal && (
                      <div className='receive-payment-item'>
                        <h4 className='fw-bold mb-0'>Portal URL</h4>
                        <input
                          type="text"
                          className="search-input"
                          placeholder="https://portal.com"
                          value={suppliercardInfo?.portalUrl || ''}
                          onChange={(e) => { handleChangeReceivePaymentInfo('url', 'portalUrl', e.target.value) }}
                        />
                      </div>
                    )}
                    {suppliercardInfo.isAcceptCardPaymentByOnlinePortal && suppliercardInfo.isAccept3rdPartyPortal && (
                      <div className='receive-payment-item'>
                        <h4 className='fw-bold mb-0'>3rd Party Portal URL</h4>
                        <input
                          type="text"
                          className="search-input"
                          placeholder="https://thirdpartyportal.com"
                          value={suppliercardInfo?.thirdPartyPortalUrl || ''}
                          onChange={(e) => { handleChangeReceivePaymentInfo('url', 'thirdPartyPortalUrl', e.target.value) }}
                        />
                      </div>
                    )}
                  </div>
                  <div className='receive-payment-item'>
                    <div className={`d-flex align-items-center`}>
                      <CheckboxComponent
                        label='Point of Sale'
                        onChange={() => { handleReceivePaymentCheckbox('isAcceptPointOfSalePortal') }}
                        checked={suppliercardInfo.isAcceptPointOfSalePortal}
                      />
                      {suppliercardInfo.isAcceptPointOfSalePortal && (
                        getRemittanceRequirements('posRemitRequirements')
                      )}
                    </div>
                  </div>
                </div>
              </div>

              <div className="item">
                <h4 className='fw-bold toggle-item-text mb-0'>Card Payment Terms</h4>
                <ThreeStateToggleButton onChange={handleTogglePaymentTerms} checked={showCardPaymentTerms} />
              </div>

              {showCardPaymentTerms && (
                <div className="item payment-terms">
                  <div className='d-flex align-items-sm-center align-items-start w-100 g-0 flex-column flex-sm-row'>
                    <h4 className='text-black fw-normal mb-0'> Payment Terms </h4>
                    <Select
                      className="payment-terms-selector ms-0 ms-sm-auto h4 mb-0"
                      options={
                        paymentTermsOptions.map((element) => (
                          {
                            label: element === 0 ? 'Upon Receipt' : element + (element === 1 ? ' Day' : ' Days'),
                            value: element === 0 ? 'Upon Receipt' : element + (element === 1 ? ' Day' : ' Days')
                          }
                        ))
                      }
                      value={{
                        label: paymentTermValue || '',
                        value: paymentTermValue || '',
                      }}
                      onChange={item => handleChangeCardPaymentTerms(item.value)}
                    />
                  </div>
                </div>
              )}

              <div className="item">
                <h4 className='fw-bold toggle-item-text mb-0'> Do They Offer Discount By Card Payment? </h4>
                <ThreeStateToggleButton onChange={handleToggleCardDiscount} checked={showCardDiscount} />
              </div>

              {showCardDiscount && (
                <div className="item card-discount d-flex flex-column flex-sm-row align-items-start align-items-sm-center">
                  {/* //flex flex-column */}
                  <h4 className='text-black fw-normal mb-0'> Card Discount: </h4>
                  <div className='flex processing-fee-dropdown-parent align-items-start align-center gap-2 flex-column'>
                    <div className='d-flex'>
                      <div className='flex processing-fee-dropdown-child flex-grow-1'>
                        <Select
                          isSearchable={false}
                          menuMaxHeight={48}
                          className="processing-fee-dropdown h4 mb-0 no-zIndex"
                          options={
                            [
                              {
                                label: '$',
                                value: 'Dollar',
                              },
                              {
                                label: '%',
                                value: 'Percentage',
                              },
                            ]
                          }
                          value={cardDiscountType}
                          onChange={item => handleChangeCardDiscountType(item)}
                        />
                        <input
                          type="text"
                          className="search-input card-discount-value-input"
                          value={suppliercardInfo?.cardDiscountValue || ''}
                          onChange={(event) => handleChangeCardDiscountValue(event.target.value, cardDiscountType?.value === 'Dollar' ? 'currency' : 'percent')}
                          placeholder={cardDiscountType?.value === 'Dollar' ? '1,234.00' : '12.50'}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              )}

              <div className="item">
                <h4 className='fw-bold toggle-item-text mb-0'> Is Card Acceptance Product Specific? </h4>
                <ThreeStateToggleButton onChange={(checked) => { handleProductSpecificOptionsChange('isAcceptProductSpecific', checked) }} checked={suppliercardInfo?.isAcceptProductSpecific} />
              </div>

              {suppliercardInfo?.isAcceptProductSpecific && (
                <div className="item payment-terms">
                  <div className='d-flex align-items-sm-center align-items-start w-100 g-0 flex-column flex-sm-row'>
                    <h4 className='text-black fw-normal mb-0'> Select Product Specific Options: </h4>
                    <Select
                      className="payment-terms-selector ms-0 ms-sm-auto h4 mb-0 no-zIndex"
                      isMulti
                      options={
                        product_specific_options.map((option) => ({
                          label: option,
                          value: option.toLowerCase().replaceAll(' ', '-')
                        }))
                      }
                      value={suppliercardInfo?.productSpecificOptions}
                      onChange={(options) => { handleProductSpecificOptionsChange('productSpecificOptions', options) }}
                    />
                  </div>
                </div>
              )}

              <div className='advance-acceptance-details-btn update-master flex flex-column'>
                {Object.keys(deliveryMethodFeeValues).length > 0 && totalDeliveryMethods > 1 && (
                  <div className="flex align-center justify-space-between advanced-details-toggle-option gap-1 ps-3 pe-3">
                    <h4 className='heading toggle-item-text text-white fw-bold mb-0'>Advanced Acceptance</h4>
                    <Toggle style={{width: 100}} size="lg" checkedChildren="Disable " unCheckedChildren="Enable" onChange={(checked) => handleToggleDisableAdvancedAcceptance(checked)} checked={suppliercardInfo?.advancedAcceptanceEnabled}/>
                  </div>
                )}

                {totalDeliveryMethods > 1 && (
                  <button className='h4 text-white fw-bold mb-0 ps-3 pe-3' onClick={() => { setShowAdvanceAccDetailsModal(!showAdvanceAccDetailsModal) }}> Go to Advanced Acceptance Detail </button>
                )}
              </div>
            </>
          )
        }
        {showAdvanceAccDetailsModal && (
          <AdvanceAcceptanceDetailsModal
            deliveryMethodTabs={deliveryMethodTabs}
            show={showAdvanceAccDetailsModal}
            onClose={handleCloseAdvanceAccDetailsModal}
            deliveryMethodValues={deliveryMethodValues}
            handleDeliveryMethodsChange={handleDeliveryMethodsChange}
            deliveryMethodFeeValues={deliveryMethodFeeValues}
            setDeliveryMethodsFeeValues={setDeliveryMethodsFeeValues}
          />
        )}
      </div>
    </div>
  )
})

export default SupplyCardAcceptance